//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export

class PagedResponseOfAcademyContent {
    
  items :
      AcademyContent[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class SimpleEntity {
    
  identifier :
      string
  ;

constructor() 
{
      this.identifier = "" ;
  }
}

export

class BaseEntity extends SimpleEntity {
    
  createdOn :
      string
  ;
    
  modifiedOn :
      string
  ;

constructor() 
{
  super();
      this.createdOn = "" ;
        this.modifiedOn = "" ;
  }
}

export

class AcademyContent extends BaseEntity {
    
  category :
      TextIdentifier 
  ;
    
  availableForCompany :
      string[]
  ;
    
  title :
      string
  ;
    
  smallDescription :
      string
  ;
    
  htmlContent :
      string
  ;
    
  order :
      number | null
  ;
    
  overrideAverageVote :
      number | null
  ;
    
  image :
      string
  ;
    
  attachment :
      string
  ;

  attachmentType :
      string
  ;

  showAs :
      string
  ;

  displayType :
      string
  ;

  disabledData :
      DisabledData
  ;

constructor()
{
  super();
      this.category = new TextIdentifier();
        this.availableForCompany = [];
        this.title = "" ;
        this.smallDescription = "" ;
        this.htmlContent = "" ;
        this.order = null;
        this.overrideAverageVote = null;
        this.image = "" ;
        this.attachment = "" ;
        this.attachmentType = "" ;
        this.showAs = "" ;
        this.displayType = "" ;
        this.disabledData = new DisabledData();
  }
}

export

class TextIdentifier {
    
  text :
      string
  ;
    
  identifier :
      string
  ;

constructor() 
{
      this.text = "" ;
        this.identifier = "" ;
  }
}

export

class DisabledData {
    
  disabledOn :
      string
  ;
    
  disabledBy :
      TextIdentifier 
  ;

constructor() 
{
      this.disabledOn = "" ;
        this.disabledBy = new TextIdentifier();
  }
}

export

class CreateAcademyVM {
    
  categoryIdentifier :
      string
  ;
    
  title :
      string
  ;
    
  smallDescription :
      string
  ;
    
  htmlContent :
      string
  ;
    
  overrideAverageVote :
      number | null
  ;
    
  order :
      number | null
  ;

  showAs :
      string
  ;

constructor()
{
      this.categoryIdentifier = "" ;
        this.title = "" ;
        this.smallDescription = "" ;
        this.htmlContent = "" ;
        this.overrideAverageVote = null;
        this.order = null;
        this.showAs = "" ;
  }
}

export

class EditAcademyVM extends CreateAcademyVM {
    
  identifier :
      string
  ;

constructor() 
{
  super();
      this.identifier = "" ;
  }
}

export

class EditAvailableForVM {
    
  companyIdentifier :
      string
  ;
    
  academyIdentifier :
      string
  ;

constructor() 
{
      this.companyIdentifier = "" ;
        this.academyIdentifier = "" ;
  }
}

export

class QuestionCountVM {
    
  total :
      number | null
  ;
    
  unanswered :
      number | null
  ;

constructor() 
{
      this.total = null;
        this.unanswered = null;
  }
}

export

class AdminQuestionListVM {
    
  identifier :
      string
  ;
    
  createdOn :
      string
  ;
    
  text :
      string
  ;
    
  commentVisibility :
      CommentVisibility | null
  ;
    
  userName :
      string
  ;
    
  userEmail :
      string
  ;
    
  userType :
      string
  ;
    
  companyName :
      string
  ;
    
  reply :
      AdminQuestionReplyVM 
  ;

constructor() 
{
      this.identifier = "" ;
        this.createdOn = "" ;
        this.text = "" ;
        this.commentVisibility = null;
        this.userName = "" ;
        this.userEmail = "" ;
        this.userType = "" ;
        this.companyName = "" ;
        this.reply = new AdminQuestionReplyVM();
  }
}

export enum CommentVisibility {
    Public = 0,
    Private = 1,
    Internal = 2,
}

export

class AdminQuestionReplyVM {
    
  identifier :
      string
  ;
    
  createdOn :
      string
  ;
    
  text :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.createdOn = "" ;
        this.text = "" ;
  }
}

export

class ReplyToQuestionVM {
    
  questionIdentifier :
      string
  ;
    
  text :
      string
  ;

constructor() 
{
      this.questionIdentifier = "" ;
        this.text = "" ;
  }
}

export

class AppUserAcademyDetailVM {

  identifier :
      string
  ;

  category :
      string
  ;

  averageVote :
      number | null
  ;

  viewCount :
      number | null
  ;

  title :
      string
  ;

  smallDescription :
      string
  ;

  htmlContent :
      string
  ;

  image :
      string
  ;

  attachment :
      string
  ;

  displayType :
      string
  ;

constructor()
{
      this.identifier = "" ;
        this.category = "" ;
        this.averageVote = null;
        this.viewCount = null;
        this.title = "" ;
        this.smallDescription = "" ;
        this.htmlContent = "" ;
        this.image = "" ;
        this.attachment = "" ;
        this.displayType = "" ;
  }
}

export

class AppUserCommentListVM {
    
  identifier :
      string
  ;
    
  createdOn :
      string
  ;
    
  text :
      string
  ;
    
  createdBy :
      TextIdentifierType 
  ;
    
  repliedToComment :
      string
  ;
    
  commentVisibility :
      CommentVisibility | null
  ;
    
  attachmentUrl :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.createdOn = "" ;
        this.text = "" ;
        this.createdBy = new TextIdentifierType();
        this.repliedToComment = "" ;
        this.commentVisibility = null;
        this.attachmentUrl = "" ;
  }
}

export

class TextIdentifierType extends TextIdentifier {
    
  type :
      string
  ;

constructor() 
{
  super();
      this.type = "" ;
  }
}

export

class CreateVoteVM {
    
  contentIdentifier :
      string
  ;
    
  value :
      number | null
  ;

constructor() 
{
      this.contentIdentifier = "" ;
        this.value = null;
  }
}

export

class CreateCommentVM {
    
  contentIdentifier :
      string
  ;
    
  text :
      string
  ;
    
  commentVisibility :
      CommentVisibility | null
  ;

constructor() 
{
      this.contentIdentifier = "" ;
        this.text = "" ;
        this.commentVisibility = null;
  }
}

export

class AppUserAcademyListVM {

  identifier :
      string
  ;

  category :
      TextIdentifier
  ;

  averageVote :
      number | null
  ;

  viewCount :
      number | null
  ;

  title :
      string
  ;

  smallDescription :
      string
  ;

  htmlContent :
      string
  ;

  image :
      string
  ;

  attachment :
      string
  ;

  displayType :
      string
  ;

constructor()
{
      this.identifier = "" ;
        this.category = new TextIdentifier();
        this.averageVote = null;
        this.viewCount = null;
        this.title = "" ;
        this.smallDescription = "" ;
        this.htmlContent = "" ;
        this.image = "" ;
        this.attachment = "" ;
        this.displayType = "" ;
  }
}

export

class AppNotification extends BaseEntity {
    
  user :
      TextIdentifier 
  ;
    
  title :
      string
  ;
    
  text :
      string
  ;
    
  readOn :
      string
  ;
    
  notificationType :
      NotificationType | null
  ;
    
  detailIdentifier :
      string
  ;

constructor() 
{
  super();
      this.user = new TextIdentifier();
        this.title = "" ;
        this.text = "" ;
        this.readOn = "" ;
        this.notificationType = null;
        this.detailIdentifier = "" ;
  }
}

export enum NotificationType {
    CommentoRicevuto = 1,
    RispostaRicevutaAcademy = 2,
    RispostaRicevutaWebinar = 3,
    PrenotazioneConfermata = 4,
    PrenotazioneAnnullata = 5,
    NuovoMessaggioRicevuto = 6,
    SupportMeetingConfermato = 7,
    SupportMeetingAnnullato = 8,
}

export

class PagedResponseOfBoughtPackage {
    
  items :
      BoughtPackage[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class BoughtPackage extends BaseEntity {
    
  user :
      TextIdentifier 
  ;
    
  company :
      TextIdentifier 
  ;
    
  buyablePackage :
      BuyablePackage 
  ;
    
  boughtPackageStatus :
      BoughtPackageStatus 
  ;
    
  transaction :
      TextIdentifier 
  ;

constructor() 
{
  super();
      this.user = new TextIdentifier();
        this.company = new TextIdentifier();
        this.buyablePackage = new BuyablePackage();
        this.boughtPackageStatus = new BoughtPackageStatus();
        this.transaction = new TextIdentifier();
  }
}

export

class BuyablePackage extends BaseEntity {
    
  category :
      TextIdentifier 
  ;
    
  consulente :
      TextIdentifier 
  ;
    
  company :
      TextIdentifier 
  ;
    
  paymentPrice :
      number | null
  ;
    
  description :
      string
  ;
    
  fullPrice :
      string
  ;
    
  finalPrice :
      string
  ;
    
  discount :
      string
  ;
    
  siteVersion :
      SiteVersion | null
  ;
    
  bookingNumber :
      number | null
  ;
    
  disabledData :
      DisabledData 
  ;

constructor() 
{
  super();
      this.category = new TextIdentifier();
        this.consulente = new TextIdentifier();
        this.company = new TextIdentifier();
        this.paymentPrice = null;
        this.description = "" ;
        this.fullPrice = "" ;
        this.finalPrice = "" ;
        this.discount = "" ;
        this.siteVersion = null;
        this.bookingNumber = null;
        this.disabledData = new DisabledData();
  }
}

export enum SiteVersion {
    Version1 = 1,
    Version2 = 2,
}

export

class BoughtPackageStatus {
    
  totalBookingNumber :
      number | null
  ;
    
  remainingBookingNumber :
      number | null
  ;
    
  usedBookingNumber :
      number | null
  ;
    
  usedByBookingIds :
      string[]
  ;

constructor() 
{
      this.totalBookingNumber = null;
        this.remainingBookingNumber = null;
        this.usedBookingNumber = null;
        this.usedByBookingIds = [];
  }
}

export

class RemainingPackagesByCategoryVM {
    
  category :
      TextIdentifier 
  ;
    
  remainingBookings :
      number | null
  ;

constructor() 
{
      this.category = new TextIdentifier();
        this.remainingBookings = null;
  }
}

export

class PagedResponseOfBuyablePackage {
    
  items :
      BuyablePackage[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class CreateBuyablePackageVM {
    
  categoryIdentifier :
      string
  ;
    
  companyIdentifier :
      string
  ;
    
  consulenteIdentifier :
      string
  ;
    
  paymentPrice :
      number | null
  ;
    
  description :
      string
  ;
    
  fullPrice :
      string
  ;
    
  finalPrice :
      string
  ;
    
  discount :
      string
  ;
    
  bookingNumber :
      number | null
  ;
    
  siteVersion :
      SiteVersion | null
  ;

constructor() 
{
      this.categoryIdentifier = "" ;
        this.companyIdentifier = "" ;
        this.consulenteIdentifier = "" ;
        this.paymentPrice = null;
        this.description = "" ;
        this.fullPrice = "" ;
        this.finalPrice = "" ;
        this.discount = "" ;
        this.bookingNumber = null;
        this.siteVersion = null;
  }
}

export

class UpdateBuyablePackageVM extends CreateBuyablePackageVM {
    
  identifier :
      string
  ;

constructor() 
{
  super();
      this.identifier = "" ;
  }
}

export

class AppUserBuyablePackageListVM {
    
  identifier :
      string
  ;
    
  description :
      string
  ;
    
  fullPrice :
      string
  ;
    
  finalPrice :
      string
  ;
    
  discount :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.description = "" ;
        this.fullPrice = "" ;
        this.finalPrice = "" ;
        this.discount = "" ;
  }
}

export

class PagedResponseOfCategoryListVM {
    
  items :
      CategoryListVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class CategoryListVM {
    
  identifier :
      string
  ;
    
  createdOn :
      string
  ;
    
  name :
      string
  ;
    
  info :
      string
  ;
    
  hexColor :
      string
  ;
    
  image :
      string
  ;
    
  video :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.createdOn = "" ;
        this.name = "" ;
        this.info = "" ;
        this.hexColor = "" ;
        this.image = "" ;
        this.video = "" ;
  }
}

export

class Category extends BaseEntity {
    
  name :
      string
  ;
    
  info :
      string
  ;
    
  hexColor :
      string
  ;
    
  image :
      string
  ;
    
  video :
      string
  ;

constructor() 
{
  super();
      this.name = "" ;
        this.info = "" ;
        this.hexColor = "" ;
        this.image = "" ;
        this.video = "" ;
  }
}

export

class CreateCategoryVM {
    
  name :
      string
  ;
    
  info :
      string
  ;
    
  hexColor :
      string
  ;

constructor() 
{
      this.name = "" ;
        this.info = "" ;
        this.hexColor = "" ;
  }
}

export

class EditCategoryVM {
    
  identifier :
      string
  ;
    
  info :
      string
  ;
    
  hexColor :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.info = "" ;
        this.hexColor = "" ;
  }
}

export

class ChatRoom extends BaseEntity {
    
  reservationId :
      string
  ;
    
  consulenteName :
      string
  ;
    
  utenteName :
      string
  ;
    
  companyName :
      string
  ;
    
  companyIdentifier :
      string
  ;
    
  companyImage :
      string
  ;
    
  prenotazione :
      string
  ;
    
  userIds :
      string[]
  ;
    
  lastMessage :
      LastMessageInfo 
  ;
    
  cancelledOn :
      string
  ;

constructor() 
{
  super();
      this.reservationId = "" ;
        this.consulenteName = "" ;
        this.utenteName = "" ;
        this.companyName = "" ;
        this.companyIdentifier = "" ;
        this.companyImage = "" ;
        this.prenotazione = "" ;
        this.userIds = [];
        this.lastMessage = new LastMessageInfo();
        this.cancelledOn = "" ;
  }
}

export

class LastMessageInfo {
    
  messageId :
      string
  ;
    
  content :
      string
  ;
    
  senderId :
      string
  ;
    
  timestamp :
      string
  ;
    
  isSeen :
      boolean
  ;

constructor() 
{
      this.messageId = "" ;
        this.content = "" ;
        this.senderId = "" ;
        this.timestamp = "" ;
        this.isSeen = false ;
  }
}

export

class ChatMessage extends BaseEntity {
    
  isSeen :
      boolean
  ;
    
  roomId :
      string
  ;
    
  senderId :
      string
  ;
    
  content :
      string
  ;
    
  timestamp :
      string
  ;
    
  replyToMessageId :
      string
  ;

constructor() 
{
  super();
      this.isSeen = false ;
        this.roomId = "" ;
        this.senderId = "" ;
        this.content = "" ;
        this.timestamp = "" ;
        this.replyToMessageId = "" ;
  }
}

export

class SendMessageRequest {
    
  content :
      string
  ;
    
  replyToMessageId :
      string
  ;

constructor() 
{
      this.content = "" ;
        this.replyToMessageId = "" ;
  }
}

export

class CustomTimezoneInfo {
    
  ianaTimeZone :
      string
  ;
    
  windowsTimeZone :
      string
  ;

constructor() 
{
      this.ianaTimeZone = "" ;
        this.windowsTimeZone = "" ;
  }
}

export

class CompanyBookingsStatsVM {
    
  todayFree :
      number | null
  ;
    
  todayPackage :
      number | null
  ;
    
  weekFree :
      number | null
  ;
    
  weekPackage :
      number | null
  ;
    
  monthFree :
      number | null
  ;
    
  monthPackage :
      number | null
  ;
    
  yearFree :
      number | null
  ;
    
  yearPackage :
      number | null
  ;

constructor() 
{
      this.todayFree = null;
        this.todayPackage = null;
        this.weekFree = null;
        this.weekPackage = null;
        this.monthFree = null;
        this.monthPackage = null;
        this.yearFree = null;
        this.yearPackage = null;
  }
}

export

class CompanyDetailVM {
    
  identifier :
      string
  ;
    
  name :
      string
  ;
    
  companyCode :
      string
  ;
    
  image :
      string
  ;
    
  timezoneInfo :
      CustomTimezoneInfo 
  ;

constructor() 
{
      this.identifier = "" ;
        this.name = "" ;
        this.companyCode = "" ;
        this.image = "" ;
        this.timezoneInfo = new CustomTimezoneInfo();
  }
}

export

class CompanyStatsVM {
    
  identifier :
      string
  ;
    
  totalUsers :
      number | null
  ;
    
  totalAppUsers :
      number | null
  ;
    
  totalFamilyUsers :
      number | null
  ;

constructor() 
{
      this.identifier = "" ;
        this.totalUsers = null;
        this.totalAppUsers = null;
        this.totalFamilyUsers = null;
  }
}

export

class PagedResponseOfCompanyListVM {
    
  items :
      CompanyListVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class CompanyListVM {
    
  identifier :
      string
  ;
    
  name :
      string
  ;
    
  companyCode :
      string
  ;
    
  isDisabled :
      boolean
  ;
    
  imageUrl :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.name = "" ;
        this.companyCode = "" ;
        this.isDisabled = false ;
        this.imageUrl = "" ;
  }
}

export

class CreateCompanyVM {
    
  name :
      string
  ;
    
  companyCode :
      string
  ;

constructor() 
{
      this.name = "" ;
        this.companyCode = "" ;
  }
}

export

class EditCompanyVM {
    
  identifier :
      string
  ;
    
  name :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.name = "" ;
  }
}

export

class EditCompanyCodeVM {
    
  identifier :
      string
  ;
    
  companyCode :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.companyCode = "" ;
  }
}

export

class BaseField extends BaseEntity {
    
  label :
      string
  ;
    
  placeholder :
      string
  ;
    
  isRequired :
      boolean
  ;
    
  type :
      FieldType | null
  ;
    
  primaryKey :
      boolean
  ;
    
  primaryKeyForeachCompany :
      boolean
  ;

constructor() 
{
  super();
      this.label = "" ;
        this.placeholder = "" ;
        this.isRequired = false ;
        this.type = null;
        this.primaryKey = false ;
        this.primaryKeyForeachCompany = false ;
  }
}

export enum FieldType {
    Text = 0,
    Number = 1,
    Date = 2,
    Select = 3,
    Checkbox = 4,
    RadioButton = 5,
}

export

class CheckboxField extends BaseField {
    
  options :
      FieldOption[]
  ;

constructor() 
{
  super();
      this.options = [];
  }
}

export

class FieldOption {
    
  value :
      string
  ;
    
  text :
      string
  ;

constructor() 
{
      this.value = "" ;
        this.text = "" ;
  }
}

export

class DateField extends BaseField {
    
  min :
      string
  ;
    
  max :
      string
  ;

constructor() 
{
  super();
      this.min = "" ;
        this.max = "" ;
  }
}

export

class NumberField extends BaseField {
    
  min :
      number | null
  ;
    
  max :
      number | null
  ;
    
  step :
      number | null
  ;

constructor() 
{
  super();
      this.min = null;
        this.max = null;
        this.step = null;
  }
}

export

class RadioButtonField extends BaseField {
    
  options :
      FieldOption[]
  ;

constructor() 
{
  super();
      this.options = [];
  }
}

export

class SelectField extends BaseField {
    
  options :
      FieldOption[]
  ;

constructor() 
{
  super();
      this.options = [];
  }
}

export

class TextField extends BaseField {
    
  validationRegex :
      string
  ;
    
  validationDescription :
      string
  ;

constructor() 
{
  super();
      this.validationRegex = "" ;
        this.validationDescription = "" ;
  }
}

export

class AppUserCompanyDetailVM {
    
  identifier :
      string
  ;
    
  name :
      string
  ;
    
  companyCode :
      string
  ;
    
  image :
      string
  ;
    
  hasConsulenze :
      boolean
  ;
    
  hasAcademy :
      boolean
  ;
    
  hasWebinar :
      boolean
  ;
    
  supportMeetingEnabled :
      boolean
  ;
    
  maxSupportMeetingsPerPerson :
      number | null
  ;
    
  siteVersion :
      SiteVersion | null
  ;
    
  enabledLanguages :
      string[]
  ;

constructor() 
{
      this.identifier = "" ;
        this.name = "" ;
        this.companyCode = "" ;
        this.image = "" ;
        this.hasConsulenze = false ;
        this.hasAcademy = false ;
        this.hasWebinar = false ;
        this.supportMeetingEnabled = false ;
        this.maxSupportMeetingsPerPerson = null;
        this.siteVersion = null;
        this.enabledLanguages = [];
  }
}

export

class ConsulenteCategoryDetailVM {
    
  identifier :
      string
  ;
    
  consulenteUser :
      TextIdentifier 
  ;
    
  category :
      TextIdentifier 
  ;
    
  businessHoursSchedule :
      CustomBusinessHoursScheduleDetailVM 
  ;
    
  spokenLanguages :
      TextIdentifier[]
  ;
    
  titoloProfessionale :
      string
  ;
    
  video :
      string
  ;
    
  description :
      string
  ;
    
  audio :
      string
  ;
    
  minimumBookingNoticeDays :
      number | null
  ;

constructor() 
{
      this.identifier = "" ;
        this.consulenteUser = new TextIdentifier();
        this.category = new TextIdentifier();
        this.businessHoursSchedule = new CustomBusinessHoursScheduleDetailVM();
        this.spokenLanguages = [];
        this.titoloProfessionale = "" ;
        this.video = "" ;
        this.description = "" ;
        this.audio = "" ;
        this.minimumBookingNoticeDays = null;
  }
}

export

class CustomBusinessHoursScheduleDetailVM {
    
  weeklyWorkSchedules :
      CustomWeeklyWorkScheduleDetailVM[]
  ;
    
  specialDaySchedules :
      CustomSpecialDayScheduleDetailVM[]
  ;

constructor() 
{
      this.weeklyWorkSchedules = [];
        this.specialDaySchedules = [];
  }
}

export

class CustomWeeklyWorkScheduleDetailVM {
    
  day :
      DayOfWeek | null
  ;
    
  dailyHours :
      CustomDailyOpeningHoursDetailVM[]
  ;

constructor() 
{
      this.day = null;
        this.dailyHours = [];
  }
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export

class CustomDailyOpeningHoursDetailVM {
    
  identifier :
      string
  ;
    
  openingTime :
      string
  ;
    
  closingTime :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.openingTime = "" ;
        this.closingTime = "" ;
  }
}

export

class CustomSpecialDayScheduleDetailVM {
    
  identifier :
      string
  ;
    
  date :
      string
  ;
    
  dailyHours :
      CustomDailyOpeningHoursDetailVM[]
  ;

constructor() 
{
      this.identifier = "" ;
        this.date = "" ;
        this.dailyHours = [];
  }
}

export

class MyConsulenteCategoryVM {
    
  identifier :
      string
  ;
    
  category :
      TextIdentifier 
  ;
    
  businessHoursSchedule :
      CustomBusinessHoursScheduleDetailVM 
  ;
    
  video :
      string
  ;
    
  description :
      string
  ;
    
  audio :
      string
  ;
    
  minimumBookingNoticeDays :
      number | null
  ;

constructor() 
{
      this.identifier = "" ;
        this.category = new TextIdentifier();
        this.businessHoursSchedule = new CustomBusinessHoursScheduleDetailVM();
        this.video = "" ;
        this.description = "" ;
        this.audio = "" ;
        this.minimumBookingNoticeDays = null;
  }
}

export

class ConsulenteCategoryCreateVM {
    
  consulenteIdentifier :
      string
  ;
    
  categoryIdentifier :
      string
  ;

constructor() 
{
      this.consulenteIdentifier = "" ;
        this.categoryIdentifier = "" ;
  }
}

export

class ConsulenteCategoryUpdateInformationVM {
    
  consulenteIdentifier :
      string
  ;
    
  categoryIdentifier :
      string
  ;
    
  description :
      string
  ;
    
  titoloProfessionale :
      string
  ;
    
  spokenLanguages :
      string[]
  ;

constructor() 
{
      this.consulenteIdentifier = "" ;
        this.categoryIdentifier = "" ;
        this.description = "" ;
        this.titoloProfessionale = "" ;
        this.spokenLanguages = [];
  }
}

export

class ConsulenteCategoryBusinessHoursScheduleAddVM {
    
  categoryIdentifier :
      string
  ;
    
  consulenteIdentifier :
      string
  ;
    
  dayOfWeek :
      DayOfWeek | null
  ;
    
  startTime :
      string
  ;
    
  endTime :
      string
  ;

constructor() 
{
      this.categoryIdentifier = "" ;
        this.consulenteIdentifier = "" ;
        this.dayOfWeek = null;
        this.startTime = "" ;
        this.endTime = "" ;
  }
}

export

class ConsulenteCategoryBusinessHoursScheduleEditVM extends ConsulenteCategoryBusinessHoursScheduleAddVM {
    
  identifier :
      string
  ;

constructor() 
{
  super();
      this.identifier = "" ;
  }
}

export

class ConsulenteCategoryBusinessHoursScheduleRemoveVM {
    
  identifier :
      string
  ;
    
  categoryIdentifier :
      string
  ;
    
  consulenteIdentifier :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.categoryIdentifier = "" ;
        this.consulenteIdentifier = "" ;
  }
}

export

class ConsulenteCategoryBusinessHoursScheduleMakeDefaultVM {
    
  categoryIdentifier :
      string
  ;
    
  consulenteIdentifier :
      string
  ;

constructor() 
{
      this.categoryIdentifier = "" ;
        this.consulenteIdentifier = "" ;
  }
}

export

class ConsulenteCategoryMakeDefaultVM {
    
  consulenteIdentifier :
      string
  ;
    
  categoryIdentifier :
      string
  ;

constructor() 
{
      this.consulenteIdentifier = "" ;
        this.categoryIdentifier = "" ;
  }
}

export

class ConsulenteCategorySpecialDayScheduleAddVM {
    
  categoryIdentifier :
      string
  ;
    
  consulenteIdentifier :
      string
  ;
    
  date :
      string
  ;
    
  startTime :
      string
  ;
    
  endTime :
      string
  ;

constructor() 
{
      this.categoryIdentifier = "" ;
        this.consulenteIdentifier = "" ;
        this.date = "" ;
        this.startTime = "" ;
        this.endTime = "" ;
  }
}

export

class ConsulenteCategorySpecialDayScheduleEditVM extends ConsulenteCategorySpecialDayScheduleAddVM {
    
  identifier :
      string
  ;

constructor() 
{
  super();
      this.identifier = "" ;
  }
}

export

class ConsulenteCategorySpecialDayScheduleRemoveVM {
    
  identifier :
      string
  ;
    
  categoryIdentifier :
      string
  ;
    
  consulenteIdentifier :
      string
  ;
    
  date :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.categoryIdentifier = "" ;
        this.consulenteIdentifier = "" ;
        this.date = "" ;
  }
}

export

class ConsulenteCategoryUpdateMinimumBookingNoticeDaysVM {
    
  consulenteIdentifier :
      string
  ;
    
  minimumBookingNoticeDays :
      number | null
  ;

constructor() 
{
      this.consulenteIdentifier = "" ;
        this.minimumBookingNoticeDays = null;
  }
}

export

class PagedResponseOfConsulenteCategorySpecialDayScheduleDetailVM {
    
  items :
      ConsulenteCategorySpecialDayScheduleDetailVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class ConsulenteCategorySpecialDayScheduleDetailVM {
    
  consulenteIdentifier :
      string
  ;
    
  categoryIdentifier :
      string
  ;
    
  date :
      string
  ;
    
  startTime :
      string
  ;
    
  endTime :
      string
  ;
    
  dailyHoursIdentifier :
      string
  ;

constructor() 
{
      this.consulenteIdentifier = "" ;
        this.categoryIdentifier = "" ;
        this.date = "" ;
        this.startTime = "" ;
        this.endTime = "" ;
        this.dailyHoursIdentifier = "" ;
  }
}

export

class PagedResponseOfContract {
    
  items :
      Contract[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class Contract extends BaseEntity {
    
  signatory :
      TextIdentifierType 
  ;
    
  period :
      CustomDatePeriod 
  ;
    
  disabledData :
      DisabledData 
  ;
    
  customerSiteSettings :
      SiteSettings 
  ;
    
  familySiteSettings :
      SiteSettings 
  ;
    
  categorySettings :
      { [key: string]: CategorySettings; }
  ;
    
  customerMeetings :
      Meetings 
  ;
    
  familyMeetings :
      Meetings 
  ;
    
  totalMeetings :
      Meetings 
  ;
    
  contractBuyablePackage :
      ContractBuyablePackage 
  ;
    
  surveyAfterMeetingNumber :
      number | null
  ;
    
  surveyMonkeyUrl :
      string
  ;
    
  allowedDomains :
      string[]
  ;
    
  blacklistedDomains :
      string[]
  ;
    
  maxInvitationsPerUser :
      number | null
  ;
    
  supportMeetingEnabled :
      boolean
  ;
    
  maxSupportMeetingsPerPerson :
      number | null
  ;

constructor() 
{
  super();
      this.signatory = new TextIdentifierType();
        this.period = new CustomDatePeriod();
        this.disabledData = new DisabledData();
        this.customerSiteSettings = new SiteSettings();
        this.familySiteSettings = new SiteSettings();
        this.categorySettings = {};
        this.customerMeetings = new Meetings();
        this.familyMeetings = new Meetings();
        this.totalMeetings = new Meetings();
        this.contractBuyablePackage = new ContractBuyablePackage();
        this.surveyAfterMeetingNumber = null;
        this.surveyMonkeyUrl = "" ;
        this.allowedDomains = [];
        this.blacklistedDomains = [];
        this.maxInvitationsPerUser = null;
        this.supportMeetingEnabled = false ;
        this.maxSupportMeetingsPerPerson = null;
  }
}

export

class DatePeriod {
    
  start :
      string
  ;
    
  end :
      string
  ;
    
  duration :
      string
  ;

constructor() 
{
      this.start = "" ;
        this.end = "" ;
        this.duration = "" ;
  }
}

export

class CustomDatePeriod extends DatePeriod {
    
  timezoneInfo :
      CustomTimezoneInfo 
  ;

constructor() 
{
  super();
      this.timezoneInfo = new CustomTimezoneInfo();
  }
}

export

class SiteSettings {
    
  siteVersion :
      SiteVersion | null
  ;
    
  hasConsulenze :
      boolean
  ;
    
  hasAcademy :
      boolean
  ;
    
  hasWebinar :
      boolean
  ;
    
  enabledLanguages :
      string[]
  ;

constructor() 
{
      this.siteVersion = null;
        this.hasConsulenze = false ;
        this.hasAcademy = false ;
        this.hasWebinar = false ;
        this.enabledLanguages = [];
  }
}

export

class CategorySettings {
    
  category :
      TextIdentifier 
  ;
    
  categoryRestrictionType :
      CategoryRestrictionType | null
  ;
    
  visibleByEmail :
      string[]
  ;
    
  categoryPositionType :
      CategoryPositionType | null
  ;
    
  categoryBookingPathType :
      CategoryBookingPathType | null
  ;
    
  baseFields :
      { [key: string]: BookingConfigurationType; }
  ;
    
  textFieldCombination :
      { [key: string]: BookingConfigurationType; }
  ;
    
  categoryCountedAsReservation :
      boolean
  ;
    
  consulenteIds :
      string[]
  ;

constructor() 
{
      this.category = new TextIdentifier();
        this.categoryRestrictionType = null;
        this.visibleByEmail = [];
        this.categoryPositionType = null;
        this.categoryBookingPathType = null;
        this.baseFields = {};
        this.textFieldCombination = {};
        this.categoryCountedAsReservation = false ;
        this.consulenteIds = [];
  }
}

export enum CategoryRestrictionType {
    Open = 0,
    Restricted = 1,
}

export enum CategoryPositionType {
    Center = 0,
    LeftSidebar = 1,
}

export enum CategoryBookingPathType {
    IlClientePrenotaIlConsulente = 0,
    PrenotaIlPrimoConsulenteDisponibile = 1,
    AdminPrenotaLaVisita = 2,
}

export enum BookingConfigurationType {
    Both = 1,
    User = 2,
    Family = 3,
}

export

class Meetings {
    
  incontriGratuiti :
      number | null
  ;
    
  percorsiMassimi :
      number | null
  ;
    
  incontriGratuitiPerCategoria :
      { [key: string]: number; }
  ;

constructor() 
{
      this.incontriGratuiti = null;
        this.percorsiMassimi = null;
        this.incontriGratuitiPerCategoria = {};
  }
}

export

class ContractBuyablePackage {
    
  totalPackagesUserCanBuy :
      number | null
  ;
    
  totalPackagesFamilyCanBuy :
      number | null
  ;
    
  totalPackagesCanBuy :
      number | null
  ;
    
  totalPackagesUserCanBuyPerCategory :
      { [key: string]: number; }
  ;
    
  totalPackagesFamilyCanBuyPerCategory :
      { [key: string]: number; }
  ;

constructor() 
{
      this.totalPackagesUserCanBuy = null;
        this.totalPackagesFamilyCanBuy = null;
        this.totalPackagesCanBuy = null;
        this.totalPackagesUserCanBuyPerCategory = {};
        this.totalPackagesFamilyCanBuyPerCategory = {};
  }
}

export

class ContractCreateVM {
    
  companyIdentifier :
      string
  ;
    
  period :
      DateOnlyPeriod 
  ;
    
  customerSiteSettings :
      SiteSettings 
  ;

constructor() 
{
      this.companyIdentifier = "" ;
        this.period = new DateOnlyPeriod();
        this.customerSiteSettings = new SiteSettings();
  }
}

export

class DateOnlyPeriod {
    
  start :
      string
  ;
    
  end :
      string
  ;

constructor() 
{
      this.start = "" ;
        this.end = "" ;
  }
}

export

class ContractUpdateBaseInfoVM {
    
  identifier :
      string
  ;
    
  period :
      DateOnlyPeriod 
  ;
    
  customerSiteSettings :
      SiteSettings 
  ;
    
  contractBuyablePackage :
      ContractBuyablePackage 
  ;
    
  allowedDomains :
      string[]
  ;
    
  blacklistedDomains :
      string[]
  ;
    
  surveyAfterMeetingNumber :
      number | null
  ;
    
  surveyMonkeyUrl :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.period = new DateOnlyPeriod();
        this.customerSiteSettings = new SiteSettings();
        this.contractBuyablePackage = new ContractBuyablePackage();
        this.allowedDomains = [];
        this.blacklistedDomains = [];
        this.surveyAfterMeetingNumber = null;
        this.surveyMonkeyUrl = "" ;
  }
}

export

class ContractUpdateMeetingsInformationVM {
    
  identifier :
      string
  ;
    
  customerMeetings :
      Meetings 
  ;
    
  familyMeetings :
      Meetings 
  ;
    
  totalMeetings :
      Meetings 
  ;
    
  supportMeetingEnabled :
      boolean
  ;
    
  maxSupportMeetingsPerPerson :
      number | null
  ;

constructor() 
{
      this.identifier = "" ;
        this.customerMeetings = new Meetings();
        this.familyMeetings = new Meetings();
        this.totalMeetings = new Meetings();
        this.supportMeetingEnabled = false ;
        this.maxSupportMeetingsPerPerson = null;
  }
}

export

class ContractUpdateCategorySettingsVM {
    
  identifier :
      string
  ;
    
  categorySettings :
      { [key: string]: CategorySettings; }
  ;

constructor() 
{
      this.identifier = "" ;
        this.categorySettings = {};
  }
}

export

class RemainingBookingVM {
    
  remainingFreeBooking :
      number | null
  ;
    
  availableBoughtPackages :
      string[]
  ;

constructor() 
{
      this.remainingFreeBooking = null;
        this.availableBoughtPackages = [];
  }
}

export

class BaseFieldWithBookingConfigurationTypeBM {
    
  baseField :
      BaseField 
  ;
    
  categoryIdentifier :
      string
  ;
    
  bookingConfigurationType :
      BookingConfigurationType | null
  ;

constructor() 
{
      this.baseField = new BaseField();
        this.categoryIdentifier = "" ;
        this.bookingConfigurationType = null;
  }
}

export

class CategoryDetailListBM extends TextIdentifier {
    
  image :
      string
  ;
    
  hexColor :
      string
  ;
    
  info :
      string
  ;

constructor() 
{
  super();
      this.image = "" ;
        this.hexColor = "" ;
        this.info = "" ;
  }
}

export

class AppUserCategoryDetailVM {
    
  categoryDetailVM :
      CategoryDetailVM 
  ;
    
  incontriTotaliERimanentiCategoryVM :
      IncontriTotaliERimanentiCategoryBM 
  ;
    
  appUserConsulentiCategoryListVM :
      AppUserConsulentiCategoryListVM[]
  ;

constructor() 
{
      this.categoryDetailVM = new CategoryDetailVM();
        this.incontriTotaliERimanentiCategoryVM = new IncontriTotaliERimanentiCategoryBM();
        this.appUserConsulentiCategoryListVM = [];
  }
}

export

class CategoryDetailVM {
    
  identifier :
      string
  ;
    
  name :
      string
  ;
    
  info :
      string
  ;
    
  hexColor :
      string
  ;
    
  image :
      string
  ;
    
  video :
      string
  ;
    
  categoryBookingPathType :
      CategoryBookingPathType | null
  ;
    
  categoryRestrictionType :
      CategoryRestrictionType | null
  ;
    
  popupTitleKey :
      string
  ;
    
  popupTextKey :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.name = "" ;
        this.info = "" ;
        this.hexColor = "" ;
        this.image = "" ;
        this.video = "" ;
        this.categoryBookingPathType = null;
        this.categoryRestrictionType = null;
        this.popupTitleKey = "" ;
        this.popupTextKey = "" ;
  }
}

export

class IncontriTotaliERimanentiBM {
    
  remainingReservation :
      number | null
  ;
    
  totalReservation :
      number | null
  ;
    
  remainingPath :
      number | null
  ;
    
  totalPath :
      number | null
  ;
    
  totalPackagesUserCanBuy :
      number | null
  ;
    
  remainingPackageBought :
      number | null
  ;
    
  isFamilyEnabled :
      boolean
  ;
    
  atuPerTuPopupTitleKey :
      string
  ;
    
  atuPerTuPopupTextKey :
      string
  ;

constructor() 
{
      this.remainingReservation = null;
        this.totalReservation = null;
        this.remainingPath = null;
        this.totalPath = null;
        this.totalPackagesUserCanBuy = null;
        this.remainingPackageBought = null;
        this.isFamilyEnabled = false ;
        this.atuPerTuPopupTitleKey = "" ;
        this.atuPerTuPopupTextKey = "" ;
  }
}

export

class IncontriTotaliERimanentiCategoryBM extends IncontriTotaliERimanentiBM {
    
  isStarted :
      boolean
  ;
    
  finishedFreeReservation :
      boolean
  ;

constructor() 
{
  super();
      this.isStarted = false ;
        this.finishedFreeReservation = false ;
  }
}

export

class AppUserConsulentiCategoryListVM {
    
  identifier :
      string
  ;
    
  titoloProfessionale :
      string
  ;
    
  spokenLanguages :
      TextIdentifier[]
  ;
    
  name :
      string
  ;
    
  image :
      string
  ;
    
  description :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.titoloProfessionale = "" ;
        this.spokenLanguages = [];
        this.name = "" ;
        this.image = "" ;
        this.description = "" ;
  }
}

export

class AppUserConsulenteDetailVM {
    
  categoryDetailVM :
      CategoryDetailVM 
  ;
    
  incontriTotaliERimanentiCategoryVM :
      IncontriTotaliERimanentiCategoryBM 
  ;
    
  appUserConsulentiCategory :
      AppUserConsulentiCategoryListVM 
  ;
    
  sidebarCategoryForCompany :
      CategoryForCompanyBM[]
  ;

constructor() 
{
      this.categoryDetailVM = new CategoryDetailVM();
        this.incontriTotaliERimanentiCategoryVM = new IncontriTotaliERimanentiCategoryBM();
        this.appUserConsulentiCategory = new AppUserConsulentiCategoryListVM();
        this.sidebarCategoryForCompany = [];
  }
}

export

class CategoryForCompanyBM {
    
  category :
      CategoryDetailListBM 
  ;
    
  categoryRestrictionType :
      CategoryRestrictionType | null
  ;
    
  categoryPositionType :
      CategoryPositionType | null
  ;
    
  categoryBookingPathType :
      CategoryBookingPathType | null
  ;
    
  freeReservation :
      number | null
  ;
    
  remainingFreeRservation :
      number | null
  ;
    
  isStarted :
      boolean
  ;

constructor() 
{
      this.category = new CategoryDetailListBM();
        this.categoryRestrictionType = null;
        this.categoryPositionType = null;
        this.categoryBookingPathType = null;
        this.freeReservation = null;
        this.remainingFreeRservation = null;
        this.isStarted = false ;
  }
}

export

class OrariPerPrenotareBM {
    
  date :
      string
  ;
    
  fasceOrarie :
      DatePeriod[]
  ;

constructor() 
{
      this.date = "" ;
        this.fasceOrarie = [];
  }
}

export

class FamilyInvitationCreateVM {
    
  company :
      string
  ;
    
  familyMemberEmail :
      string
  ;

constructor() 
{
      this.company = "" ;
        this.familyMemberEmail = "" ;
  }
}

export

class PagedResponseOfFamilyInvitationListVM {
    
  items :
      FamilyInvitationListVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class FamilyInvitationListVM {
    
  identifier :
      string
  ;
    
  company :
      TextIdentifier 
  ;
    
  contract :
      string
  ;
    
  invitedBy :
      TextIdentifier 
  ;
    
  familyMemberEmail :
      string
  ;
    
  acceptedBy :
      TextIdentifier 
  ;
    
  status :
      InvitationStatus | null
  ;
    
  createdOn :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.company = new TextIdentifier();
        this.contract = "" ;
        this.invitedBy = new TextIdentifier();
        this.familyMemberEmail = "" ;
        this.acceptedBy = new TextIdentifier();
        this.status = null;
        this.createdOn = "" ;
  }
}

export enum InvitationStatus {
    Pending = 0,
    Accepted = 1,
    Rejected = 2,
}

export

class FamilyInvitationResponseVM {
    
  invitationId :
      string
  ;
    
  familyMemberEmail :
      string
  ;
    
  status :
      InvitationStatus | null
  ;
    
  otp :
      string
  ;

constructor() 
{
      this.invitationId = "" ;
        this.familyMemberEmail = "" ;
        this.status = null;
        this.otp = "" ;
  }
}

export

class FamilyInvitationDetailsVM {
    
  invitationId :
      string
  ;
    
  inviterName :
      string
  ;
    
  companyName :
      string
  ;
    
  familyMemberEmail :
      string
  ;
    
  status :
      InvitationStatus | null
  ;

constructor() 
{
      this.invitationId = "" ;
        this.inviterName = "" ;
        this.companyName = "" ;
        this.familyMemberEmail = "" ;
        this.status = null;
  }
}

export

class AcceptInvitationVM {
    
  invitationId :
      string
  ;
    
  otpCode :
      string
  ;
    
  name :
      string
  ;
    
  surname :
      string
  ;
    
  password :
      string
  ;

constructor() 
{
      this.invitationId = "" ;
        this.otpCode = "" ;
        this.name = "" ;
        this.surname = "" ;
        this.password = "" ;
  }
}

export

class RejectInvitationVM {
    
  invitationId :
      string
  ;
    
  otpCode :
      string
  ;

constructor() 
{
      this.invitationId = "" ;
        this.otpCode = "" ;
  }
}

export

class PagedResponseOfFaqEntry {
    
  items :
      FaqEntry[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class FaqEntry extends BaseEntity {
    
  title :
      string
  ;
    
  htmlText :
      string
  ;
    
  company :
      TextIdentifier 
  ;
    
  disabledData :
      DisabledData 
  ;

constructor() 
{
  super();
      this.title = "" ;
        this.htmlText = "" ;
        this.company = new TextIdentifier();
        this.disabledData = new DisabledData();
  }
}

export

class FaqEntryCreateVM {
    
  title :
      string
  ;
    
  htmlText :
      string
  ;
    
  companyIdentifier :
      string
  ;

constructor() 
{
      this.title = "" ;
        this.htmlText = "" ;
        this.companyIdentifier = "" ;
  }
}

export

class AppUserFaqListVM {
    
  identifier :
      string
  ;
    
  title :
      string
  ;
    
  htmlText :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.title = "" ;
        this.htmlText = "" ;
  }
}

export

class PagedResponseOfTextFieldCombination {
    
  items :
      TextFieldCombination[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class TextFieldCombination extends BaseEntity {
    
  description :
      string
  ;
    
  fields :
      string[]
  ;
    
  validCombinations :
      { [key: string]: string; }[]
  ;

constructor() 
{
  super();
      this.description = "" ;
        this.fields = [];
        this.validCombinations = [];
  }
}

export

class CreateTextFieldCombinationVM {
    
  description :
      string
  ;
    
  fields :
      string[]
  ;

constructor() 
{
      this.description = "" ;
        this.fields = [];
  }
}

export

class UpdateTextFieldCombinationVM extends CreateTextFieldCombinationVM {
    
  identifier :
      string
  ;
    
  validCombinations :
      { [key: string]: string; }[]
  ;

constructor() 
{
  super();
      this.identifier = "" ;
        this.validCombinations = [];
  }
}

export

class FieldCombinationListVM extends TextIdentifier {
    
  fields :
      string[]
  ;

constructor() 
{
  super();
      this.fields = [];
  }
}

export

class PagedResponseOfBaseField {
    
  items :
      BaseField[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class BaseCreateFieldVM {
    
  label :
      string
  ;
    
  placeholder :
      string
  ;
    
  isRequired :
      boolean
  ;
    
  primaryKey :
      boolean
  ;
    
  primaryKeyForeachCompany :
      boolean
  ;

constructor() 
{
      this.label = "" ;
        this.placeholder = "" ;
        this.isRequired = false ;
        this.primaryKey = false ;
        this.primaryKeyForeachCompany = false ;
  }
}

export

class CreateFieldWithOptionsVM extends BaseCreateFieldVM {
    
  options :
      FieldOption[]
  ;

constructor() 
{
  super();
      this.options = [];
  }
}

export

class UpdateFieldWithOptionsVM extends CreateFieldWithOptionsVM {
    
  identifier :
      string
  ;

constructor() 
{
  super();
      this.identifier = "" ;
  }
}

export

class CreateDateFieldVM extends BaseCreateFieldVM {
    
  min :
      string
  ;
    
  max :
      string
  ;

constructor() 
{
  super();
      this.min = "" ;
        this.max = "" ;
  }
}

export

class UpdateDateFieldVM extends CreateDateFieldVM {
    
  identifier :
      string
  ;

constructor() 
{
  super();
      this.identifier = "" ;
  }
}

export

class CreateNumberFieldVM extends BaseCreateFieldVM {
    
  min :
      number | null
  ;
    
  max :
      number | null
  ;
    
  step :
      number | null
  ;

constructor() 
{
  super();
      this.min = null;
        this.max = null;
        this.step = null;
  }
}

export

class UpdateNumberFieldVM extends CreateNumberFieldVM {
    
  identifier :
      string
  ;

constructor() 
{
  super();
      this.identifier = "" ;
  }
}

export

class CreateTextFieldVM extends BaseCreateFieldVM {
    
  validationRegex :
      string
  ;
    
  validationDescription :
      string
  ;

constructor() 
{
  super();
      this.validationRegex = "" ;
        this.validationDescription = "" ;
  }
}

export

class UpdateTextFieldVM extends CreateTextFieldVM {
    
  identifier :
      string
  ;

constructor() 
{
  super();
      this.identifier = "" ;
  }
}

export

class PagedResponseOfLoginLogListVM {
    
  items :
      LoginLogListVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class LoginLogListVM {
    
  identifier :
      string
  ;
    
  createdOn :
      string
  ;
    
  userIdentifier :
      string
  ;
    
  username :
      string
  ;
    
  completeName :
      string
  ;
    
  companyCode :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.createdOn = "" ;
        this.userIdentifier = "" ;
        this.username = "" ;
        this.completeName = "" ;
        this.companyCode = "" ;
  }
}

export

class LoginLogFilterVM {
    
  companyCode :
      string[]
  ;

constructor() 
{
      this.companyCode = [];
  }
}

export

class StripeCardDetailBM {
    
  cardId :
      string
  ;
    
  brand :
      string
  ;
    
  country :
      string
  ;
    
  currency :
      string
  ;
    
  expMonth :
      number | null
  ;
    
  expYear :
      number | null
  ;
    
  dynamicLast4 :
      string
  ;
    
  last4 :
      string
  ;
    
  holder :
      string
  ;

constructor() 
{
      this.cardId = "" ;
        this.brand = "" ;
        this.country = "" ;
        this.currency = "" ;
        this.expMonth = null;
        this.expYear = null;
        this.dynamicLast4 = "" ;
        this.last4 = "" ;
        this.holder = "" ;
  }
}

export

class PagedResponseOfViewModel {
    
  items :
      ViewModel[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class ViewModel extends BaseEntity {
    
  company :
      TextIdentifier 
  ;
    
  viewedBy :
      TextIdentifierType 
  ;
    
  content :
      TextIdentifierType 
  ;

constructor() 
{
  super();
      this.company = new TextIdentifier();
        this.viewedBy = new TextIdentifierType();
        this.content = new TextIdentifierType();
  }
}

export

class PagedResponseOfVoteModel {
    
  items :
      VoteModel[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class VoteModel extends BaseEntity {
    
  value :
      number | null
  ;
    
  votedBy :
      TextIdentifierType 
  ;
    
  company :
      TextIdentifier 
  ;
    
  content :
      TextIdentifierType 
  ;

constructor() 
{
  super();
      this.value = null;
        this.votedBy = new TextIdentifierType();
        this.company = new TextIdentifier();
        this.content = new TextIdentifierType();
  }
}

export

class PagedResponseOfWebinarContent {
    
  items :
      WebinarContent[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class WebinarContent extends BaseEntity {
    
  company :
      TextIdentifier 
  ;
    
  category :
      TextIdentifier 
  ;
    
  title :
      string
  ;
    
  smallDescription :
      string
  ;
    
  htmlContent :
      string
  ;
    
  image :
      string
  ;
    
  period :
      CustomDatePeriod 
  ;
    
  link :
      string
  ;
    
  order :
      number | null
  ;
    
  disabledData :
      DisabledData 
  ;

constructor() 
{
  super();
      this.company = new TextIdentifier();
        this.category = new TextIdentifier();
        this.title = "" ;
        this.smallDescription = "" ;
        this.htmlContent = "" ;
        this.image = "" ;
        this.period = new CustomDatePeriod();
        this.link = "" ;
        this.order = null;
        this.disabledData = new DisabledData();
  }
}

export

class WebinarContentCreateVM {
    
  companyIdentifier :
      string
  ;
    
  categoryIdentifier :
      string
  ;
    
  title :
      string
  ;
    
  smallDescription :
      string
  ;
    
  htmlContent :
      string
  ;
    
  period :
      DatePeriod 
  ;
    
  link :
      string
  ;
    
  order :
      number | null
  ;

constructor() 
{
      this.companyIdentifier = "" ;
        this.categoryIdentifier = "" ;
        this.title = "" ;
        this.smallDescription = "" ;
        this.htmlContent = "" ;
        this.period = new DatePeriod();
        this.link = "" ;
        this.order = null;
  }
}

export

class WebinarContentUpdateVM {
    
  identifier :
      string
  ;
    
  categoryIdentifier :
      string
  ;
    
  title :
      string
  ;
    
  smallDescription :
      string
  ;
    
  htmlContent :
      string
  ;
    
  period :
      DatePeriod 
  ;
    
  link :
      string
  ;
    
  order :
      number | null
  ;

constructor() 
{
      this.identifier = "" ;
        this.categoryIdentifier = "" ;
        this.title = "" ;
        this.smallDescription = "" ;
        this.htmlContent = "" ;
        this.period = new DatePeriod();
        this.link = "" ;
        this.order = null;
  }
}

export

class AppUserWebinairDetailVM {
    
  identifier :
      string
  ;
    
  title :
      string
  ;
    
  smallDescription :
      string
  ;
    
  htmlContent :
      string
  ;
    
  image :
      string
  ;
    
  period :
      DatePeriod 
  ;
    
  link :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.title = "" ;
        this.smallDescription = "" ;
        this.htmlContent = "" ;
        this.image = "" ;
        this.period = new DatePeriod();
        this.link = "" ;
  }
}

export

class AppUserWebinairListVM {
    
  identifier :
      string
  ;
    
  category :
      TextIdentifier 
  ;
    
  period :
      DatePeriod 
  ;
    
  title :
      string
  ;
    
  image :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.category = new TextIdentifier();
        this.period = new DatePeriod();
        this.title = "" ;
        this.image = "" ;
  }
}

export

class BaseApiLoginResponseOfLoggedUserVM {
    
  identifier :
      string
  ;
    
  username :
      string
  ;
    
  role :
      string
  ;
    
  token :
      string
  ;
    
  refreshToken :
      string
  ;
    
  refreshTokenExpiryTime :
      string
  ;
    
  deviceID :
      string
  ;
    
  loggedEntityData :
      LoggedUserVM 
  ;

constructor() 
{
      this.identifier = "" ;
        this.username = "" ;
        this.role = "" ;
        this.token = "" ;
        this.refreshToken = "" ;
        this.refreshTokenExpiryTime = "" ;
        this.deviceID = "" ;
        this.loggedEntityData = new LoggedUserVM();
  }
}

export

class LoggedUserVM {
    
  identifier :
      string
  ;
    
  username :
      string
  ;
    
  name :
      string
  ;
    
  surname :
      string
  ;
    
  completeName :
      string
  ;
    
  profileImage :
      string
  ;
    
  preferredCulture :
      string
  ;
    
  role :
      string
  ;
    
  token :
      string
  ;
    
  refreshToken :
      string
  ;
    
  refreshTokenExpiryTime :
      string
  ;
  
  carolDataControllerConsent :
      any
  ;

  companyIdentifier :
      string
  ;
    
  additionalData :
      { [key: string]: string[]; }
  ;

constructor() 
{
      this.identifier = "" ;
        this.username = "" ;
        this.name = "" ;
        this.surname = "" ;
        this.completeName = "" ;
        this.profileImage = "" ;
        this.preferredCulture = "" ;
        this.role = "" ;
        this.token = "" ;
          this.refreshToken = "" ;
          this.refreshTokenExpiryTime = "" ;
          this.carolDataControllerConsent = null;
          this.companyIdentifier = "" ;
          this.additionalData = {};
  }
}

export

class ConfirmUserVM {
    
  code :
      string
  ;
    
  userIdentifier :
      string
  ;

constructor() 
{
      this.code = "" ;
        this.userIdentifier = "" ;
  }
}

export

class ChangePasswordVM {
    
  username :
      string
  ;
    
  otpCode :
      string
  ;
    
  newPassword :
      string
  ;

constructor() 
{
      this.username = "" ;
        this.otpCode = "" ;
        this.newPassword = "" ;
  }
}

export

class AppUserStatsVM {
    
  totalUsers :
      number | null
  ;
    
  totalActiveUsers :
      number | null
  ;
    
  totalNonActiveUsers :
      number | null
  ;
    
  totalUsersLast30 :
      number | null
  ;
    
  totalAppUsers :
      number | null
  ;
    
  totalFamilyUsers :
      number | null
  ;

constructor() 
{
      this.totalUsers = null;
        this.totalActiveUsers = null;
        this.totalNonActiveUsers = null;
        this.totalUsersLast30 = null;
        this.totalAppUsers = null;
        this.totalFamilyUsers = null;
  }
}

export

class PagedResponseOfAppUserListVM {
    
  items :
      AppUserListVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class AppUserListVM {
    
  identifier :
      string
  ;
    
  company :
      TextIdentifier 
  ;
    
  username :
      string
  ;
    
  personalData :
      PersonalData 
  ;
    
  additionalData :
      { [key: string]: string[]; }
  ;
    
  isDisabled :
      boolean
  ;
    
  isFamilyUser :
      boolean
  ;
    
  isEmailConfirmed :
      boolean
  ;
    
  createdOn :
      string
  ;
    
  lastLoginOn :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.company = new TextIdentifier();
        this.username = "" ;
        this.personalData = new PersonalData();
        this.additionalData = {};
        this.isDisabled = false ;
        this.isFamilyUser = false ;
        this.isEmailConfirmed = false ;
        this.createdOn = "" ;
        this.lastLoginOn = "" ;
  }
}

export

class PersonalData {
    
  name :
      string
  ;
    
  surname :
      string
  ;
    
  profileImage :
      string
  ;
    
  completeName :
      string
  ;

constructor() 
{
      this.name = "" ;
        this.surname = "" ;
        this.profileImage = "" ;
        this.completeName = "" ;
  }
}

export

class PagedResponseOfAppUserConsulenteListVM {
    
  items :
      AppUserConsulenteListVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class AppUserConsulenteListVM {
    
  identifier :
      string
  ;
    
  company :
      TextIdentifier 
  ;
    
  username :
      string
  ;
    
  personalData :
      PersonalData 
  ;
    
  categories :
      TextIdentifier[]
  ;
    
  isDisabled :
      boolean
  ;
    
  isFamilyUser :
      boolean
  ;

constructor() 
{
      this.identifier = "" ;
        this.company = new TextIdentifier();
        this.username = "" ;
        this.personalData = new PersonalData();
        this.categories = [];
        this.isDisabled = false ;
        this.isFamilyUser = false ;
  }
}

export

class AppUserCreateVM {
    
  companyIdentifier :
      string
  ;
    
  username :
      string
  ;
    
  password :
      string
  ;
    
  preferredCulture :
      string
  ;
    
  personalData :
      PersonalData 
  ;
    
  additionalData :
      { [key: string]: string[]; }
  ;

constructor() 
{
      this.companyIdentifier = "" ;
        this.username = "" ;
        this.password = "" ;
        this.preferredCulture = "" ;
        this.personalData = new PersonalData();
        this.additionalData = {};
  }
}

export

class UpdateNameAndSurnameVM {
    
  name :
      string
  ;
    
  surname :
      string
  ;

constructor() 
{
      this.name = "" ;
        this.surname = "" ;
  }
}

export

class AppUserRegisterVM {
    
  companyCode :
      string
  ;
    
  username :
      string
  ;
    
  password :
      string
  ;
    
  preferredCulture :
      string
  ;
    
  personalData :
      PersonalData 
  ;
    
  additionalData :
      { [key: string]: string[]; }
  ;

constructor() 
{
      this.companyCode = "" ;
        this.username = "" ;
        this.password = "" ;
        this.preferredCulture = "" ;
        this.personalData = new PersonalData();
        this.additionalData = {};
  }
}

export

class AppUserLoginVM {
    
  username :
      string
  ;
    
  password :
      string
  ;
    
  companyCode :
      string
  ;

constructor() 
{
      this.username = "" ;
        this.password = "" ;
        this.companyCode = "" ;
  }
}

export

class ChangeEmailVM {
    
  userIdentifier :
      string
  ;
    
  newEmail :
      string
  ;

constructor() 
{
      this.userIdentifier = "" ;
        this.newEmail = "" ;
  }
}

export

class RefreshTokenVM {
    
  token :
      string
  ;
    
  refreshToken :
      string
  ;
    
  refreshTokenExpiryTime :
      string
  ;
    
  device :
      BaseDevice | undefined
  ;

constructor() 
{
      this.token = "" ;
        this.refreshToken = "" ;
        this.refreshTokenExpiryTime = "" ;
  }
}

export

class BaseDevice {
    
  ipAddress :
      string
  ;
    
  deviceID :
      string | undefined
  ;

constructor() 
{
      this.ipAddress = "" ;
  }
}

export

class BaseCredential {
    
  username :
      string
  ;
    
  password :
      string
  ;
    
  deviceID :
      string
  ;

constructor() 
{
      this.username = "" ;
        this.password = "" ;
        this.deviceID = "" ;
  }
}

export

class CultureBaseCredential extends BaseCredential {
    
  preferredCulture :
      string
  ;

constructor() 
{
  super();
      this.preferredCulture = "" ;
  }
}

export

class ConfirmVM {
    
  username :
      string
  ;
    
  confirmationCode :
      string
  ;

constructor() 
{
      this.username = "" ;
        this.confirmationCode = "" ;
  }
}

export

class PagedResponseOfConsulenteUserListVM {
    
  items :
      ConsulenteUserListVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class ConsulenteUserListVM {
    
  identifier :
      string
  ;
    
  username :
      string
  ;
    
  personalData :
      PersonalData 
  ;
    
  image :
      string
  ;
    
  categories :
      TextIdentifier[]
  ;
    
  isDisabled :
      boolean
  ;
    
  isEmailConfirmed :
      boolean
  ;

constructor() 
{
      this.identifier = "" ;
        this.username = "" ;
        this.personalData = new PersonalData();
        this.image = "" ;
        this.categories = [];
        this.isDisabled = false ;
        this.isEmailConfirmed = false ;
  }
}

export

class ConsulenteUserDetailVM {
    
  identifier :
      string
  ;
    
  image :
      string
  ;
    
  username :
      string
  ;
    
  preferredCulture :
      string
  ;
    
  personalData :
      PersonalData 
  ;
    
  isDisabled :
      boolean
  ;
    
  timezoneInfo :
      CustomTimezoneInfo 
  ;

constructor() 
{
      this.identifier = "" ;
        this.image = "" ;
        this.username = "" ;
        this.preferredCulture = "" ;
        this.personalData = new PersonalData();
        this.isDisabled = false ;
        this.timezoneInfo = new CustomTimezoneInfo();
  }
}

export

class ConsulenteUserCreateVM {
    
  username :
      string
  ;
    
  password :
      string
  ;
    
  preferredCulture :
      string
  ;
    
  personalData :
      PersonalData 
  ;

constructor() 
{
      this.username = "" ;
        this.password = "" ;
        this.preferredCulture = "" ;
        this.personalData = new PersonalData();
  }
}

export

class AdminSupportAvailabilityVM {
    
  exists :
      boolean
  ;
    
  identifier :
      string
  ;
    
  businessHoursSchedule :
      CustomBusinessHoursSchedule 
  ;
    
  slotDurationMinutes :
      number | null
  ;
    
  minimumBookingNoticeDays :
      number | null
  ;

constructor() 
{
      this.exists = false ;
        this.identifier = "" ;
        this.businessHoursSchedule = new CustomBusinessHoursSchedule();
        this.slotDurationMinutes = null;
        this.minimumBookingNoticeDays = null;
  }
}

export

class CustomBusinessHoursSchedule {
    
  weeklyWorkSchedules :
      CustomWeeklyWorkSchedule[]
  ;
    
  specialDaySchedules :
      CustomSpecialDaySchedule[]
  ;

constructor() 
{
      this.weeklyWorkSchedules = [];
        this.specialDaySchedules = [];
  }
}

export

class CustomWeeklyWorkSchedule {
    
  day :
      DayOfWeek | null
  ;
    
  dailyHours :
      CustomDailyOpeningHours[]
  ;

constructor() 
{
      this.day = null;
        this.dailyHours = [];
  }
}

export

class CustomDailyOpeningHours {
    
  identifier :
      string
  ;
    
  timezoneInfo :
      CustomTimezoneInfo 
  ;
    
  openingTime :
      string
  ;
    
  closingTime :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.timezoneInfo = new CustomTimezoneInfo();
        this.openingTime = "" ;
        this.closingTime = "" ;
  }
}

export

class CustomSpecialDaySchedule {
    
  identifier :
      string
  ;
    
  date :
      string
  ;
    
  dailyHours :
      CustomDailyOpeningHours[]
  ;

constructor() 
{
      this.identifier = "" ;
        this.date = "" ;
        this.dailyHours = [];
  }
}

export

class UpdateAdminSupportAvailabilityVM {
    
  businessHoursSchedule :
      CustomBusinessHoursSchedule 
  ;
    
  minimumBookingNoticeDays :
      number | null
  ;

constructor() 
{
      this.businessHoursSchedule = new CustomBusinessHoursSchedule();
        this.minimumBookingNoticeDays = null;
  }
}

export

class UpdateBusinessHoursScheduleVM {
    
  businessHoursSchedule :
      CustomBusinessHoursSchedule 
  ;

constructor() 
{
      this.businessHoursSchedule = new CustomBusinessHoursSchedule();
  }
}

export

class UpdateMinimumBookingNoticeDaysVM {
    
  minimumBookingNoticeDays :
      number | null
  ;

constructor() 
{
      this.minimumBookingNoticeDays = null;
  }
}

export

class AddAdminSupportHoursVM {
    
  dayOfWeek :
      number | null
  ;
    
  startTime :
      string
  ;
    
  endTime :
      string
  ;

constructor() 
{
      this.dayOfWeek = null;
        this.startTime = "" ;
        this.endTime = "" ;
  }
}

export

class EditAdminSupportHoursVM {
    
  identifier :
      string
  ;
    
  dayOfWeek :
      number | null
  ;
    
  startTime :
      string
  ;
    
  endTime :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.dayOfWeek = null;
        this.startTime = "" ;
        this.endTime = "" ;
  }
}

export

class RemoveAdminSupportHoursVM {
    
  identifier :
      string
  ;

constructor() 
{
      this.identifier = "" ;
  }
}

export

class AvailableSlotVM {
    
  start :
      string
  ;
    
  end :
      string
  ;

constructor() 
{
      this.start = "" ;
        this.end = "" ;
  }
}

export

class AdminSupportAvailabilityPublicVM {
    
  exists :
      boolean
  ;
    
  adminUserIdentifier :
      string
  ;
    
  adminName :
      string
  ;
    
  businessHoursSchedule :
      CustomBusinessHoursSchedule 
  ;
    
  slotDurationMinutes :
      number | null
  ;
    
  minimumBookingNoticeDays :
      number | null
  ;

constructor() 
{
      this.exists = false ;
        this.adminUserIdentifier = "" ;
        this.adminName = "" ;
        this.businessHoursSchedule = new CustomBusinessHoursSchedule();
        this.slotDurationMinutes = null;
        this.minimumBookingNoticeDays = null;
  }
}

export

class CreateSupportMeetingVM {
    
  adminUserIdentifier :
      string
  ;
    
  period :
      DatePeriod 
  ;

constructor() 
{
      this.adminUserIdentifier = "" ;
        this.period = new DatePeriod();
  }
}

export

class SupportMeetingListVM {
    
  identifier :
      string
  ;
    
  start :
      string
  ;
    
  end :
      string
  ;
    
  timezoneIana :
      string
  ;
    
  adminName :
      string
  ;
    
  linkIncontro :
      string
  ;
    
  isCancelled :
      boolean
  ;
    
  cancelledOn :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.start = "" ;
        this.end = "" ;
        this.timezoneIana = "" ;
        this.adminName = "" ;
        this.linkIncontro = "" ;
        this.isCancelled = false ;
        this.cancelledOn = "" ;
  }
}

export

class SupportMeetingStatsVM {
    
  total :
      number | null
  ;
    
  remaining :
      number | null
  ;

constructor() 
{
      this.total = null;
        this.remaining = null;
  }
}

export

class CanBookSupportMeetingVM {
    
  canBook :
      boolean
  ;
    
  supportMeetingEnabled :
      boolean
  ;
    
  currentCount :
      number | null
  ;
    
  maxAllowed :
      number | null
  ;

constructor() 
{
      this.canBook = false ;
        this.supportMeetingEnabled = false ;
        this.currentCount = null;
        this.maxAllowed = null;
  }
}

export

class CreateSupportMeetingByAdminVM {
    
  appUserIdentifier :
      string
  ;
    
  companyIdentifier :
      string
  ;
    
  period :
      DatePeriod 
  ;

constructor() 
{
      this.appUserIdentifier = "" ;
        this.companyIdentifier = "" ;
        this.period = new DatePeriod();
  }
}

export

class PagedResponseOfSupportMeetingAdminListVM {
    
  items :
      SupportMeetingAdminListVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class SupportMeetingAdminListVM {
    
  identifier :
      string
  ;
    
  start :
      string
  ;
    
  end :
      string
  ;
    
  timezoneIana :
      string
  ;
    
  appUser :
      TextIdentifier 
  ;
    
  appUserCompleteName :
      string
  ;
    
  company :
      TextIdentifier 
  ;
    
  linkIncontro :
      string
  ;
    
  isCancelled :
      boolean
  ;
    
  cancelledOn :
      string
  ;
    
  createdOn :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.start = "" ;
        this.end = "" ;
        this.timezoneIana = "" ;
        this.appUser = new TextIdentifier();
        this.appUserCompleteName = "" ;
        this.company = new TextIdentifier();
        this.linkIncontro = "" ;
        this.isCancelled = false ;
        this.cancelledOn = "" ;
        this.createdOn = "" ;
  }
}

export

class UpdateLinkIncontroVM {
    
  supportMeetingIdentifier :
      string
  ;
    
  linkIncontro :
      string
  ;

constructor() 
{
      this.supportMeetingIdentifier = "" ;
        this.linkIncontro = "" ;
  }
}

export

class PagedResponseOfSpokenLanguage {
    
  items :
      SpokenLanguage[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class SpokenLanguage extends BaseEntity {
    
  name :
      string
  ;
    
  image :
      string
  ;

constructor() 
{
  super();
      this.name = "" ;
        this.image = "" ;
  }
}

export

class SpokenLanguageCreateVM {
    
  name :
      string
  ;

constructor() 
{
      this.name = "" ;
  }
}

export

class MandatoryDocumentCategoryCreateVM {
    
  category :
      string
  ;

constructor() 
{
      this.category = "" ;
  }
}

export

class MandatoryDocumentCategoryEditVM extends MandatoryDocumentCategoryCreateVM {
    
  identifier :
      string
  ;

constructor() 
{
  super();
      this.identifier = "" ;
  }
}

export

class PagedResponseOfMandatoryDocumentCategoryListVM {
    
  items :
      MandatoryDocumentCategoryListVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class MandatoryDocumentCategoryListVM {
    
  identifier :
      string
  ;
    
  category :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.category = "" ;
  }
}

export

class PagedResponseOfMandatoryDocumentListVM {
    
  items :
      MandatoryDocumentListVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class MandatoryDocumentListVM {
    
  identifier :
      string
  ;
    
  category :
      TextIdentifier 
  ;
    
  mandatoryDocumentDetail :
      MandatoryDocumentDetail 
  ;
    
  company :
      TextIdentifier 
  ;
    
  isPublished :
      boolean
  ;
    
  type :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.category = new TextIdentifier();
        this.mandatoryDocumentDetail = new MandatoryDocumentDetail();
        this.company = new TextIdentifier();
        this.isPublished = false ;
        this.type = "" ;
  }
}

export

class MandatoryDocumentDetail {
    
  phraseToShow :
      string
  ;
    
  documentName :
      string
  ;
    
  urlDocument :
      string
  ;

constructor() 
{
      this.phraseToShow = "" ;
        this.documentName = "" ;
        this.urlDocument = "" ;
  }
}

export

class CreateMandatoryDocumentVM {
    
  categoryIdentifier :
      string
  ;
    
  phraseToShow :
      string
  ;
    
  documentName :
      string
  ;
    
  companyIdentifier :
      string
  ;

constructor() 
{
      this.categoryIdentifier = "" ;
        this.phraseToShow = "" ;
        this.documentName = "" ;
        this.companyIdentifier = "" ;
  }
}

export

class EditMandatoryDocumentVM extends CreateMandatoryDocumentVM {
    
  identifier :
      string
  ;

constructor() 
{
  super();
      this.identifier = "" ;
  }
}

export

class MandatoryDocumentVM {
    
  identifier :
      string
  ;
    
  phraseToShow :
      string
  ;
    
  documentName :
      string
  ;
    
  urlDocument :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.phraseToShow = "" ;
        this.documentName = "" ;
        this.urlDocument = "" ;
  }
}

export

class Country {
    
  name :
      string
  ;
    
  alpha2Code :
      string
  ;
    
  alpha3Code :
      string
  ;
    
  numericCode :
      string
  ;

constructor() 
{
      this.name = "" ;
        this.alpha2Code = "" ;
        this.alpha3Code = "" ;
        this.numericCode = "" ;
  }
}

export

class ExtendedCountry extends Country {
    
  currencies :
      Currency[]
  ;
    
  languages :
      Language[]
  ;
    
  callingCodes :
      string[]
  ;
    
  countryNameTranslation :
      CountryTranslation 
  ;
    
  timezones :
      string[]
  ;
    
  topLevelDomains :
      string[]
  ;
    
  flagUrl :
      string
  ;

constructor() 
{
  super();
      this.currencies = [];
        this.languages = [];
        this.callingCodes = [];
        this.countryNameTranslation = new CountryTranslation();
        this.timezones = [];
        this.topLevelDomains = [];
        this.flagUrl = "" ;
  }
}

export

class Currency {
    
  code :
      string
  ;
    
  name :
      string
  ;
    
  symbol :
      string
  ;

constructor() 
{
      this.code = "" ;
        this.name = "" ;
        this.symbol = "" ;
  }
}

export

class Language {
    
  iso639_1 :
      string
  ;
    
  iso639_2 :
      string
  ;
    
  name :
      string
  ;
    
  nativeName :
      string
  ;

constructor() 
{
      this.iso639_1 = "" ;
        this.iso639_2 = "" ;
        this.name = "" ;
        this.nativeName = "" ;
  }
}

export

class CountryTranslation {
    
  de :
      string
  ;
    
  es :
      string
  ;
    
  fr :
      string
  ;
    
  ja :
      string
  ;
    
  it :
      string
  ;
    
  br :
      string
  ;
    
  pt :
      string
  ;

constructor() 
{
      this.de = "" ;
        this.es = "" ;
        this.fr = "" ;
        this.ja = "" ;
        this.it = "" ;
        this.br = "" ;
        this.pt = "" ;
  }
}

export

class PagedResponseOfMailEventListVM {
    
  items :
      MailEventListVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class MailEventListVM {
    
  identifier :
      string
  ;
    
  createdOn :
      string
  ;
    
  parentObject :
      TextIdentifierType 
  ;
    
  to :
      TextIdentifierType 
  ;
    
  label :
      string
  ;
    
  email :
      string
  ;
    
  mailJetMessageResult :
      MailJetMessageResultVM 
  ;
    
  resendEmailNumbers :
      number | null
  ;

constructor() 
{
      this.identifier = "" ;
        this.createdOn = "" ;
        this.parentObject = new TextIdentifierType();
        this.to = new TextIdentifierType();
        this.label = "" ;
        this.email = "" ;
        this.mailJetMessageResult = new MailJetMessageResultVM();
        this.resendEmailNumbers = null;
  }
}

export

class MailJetMessageResultVM {
    
  status :
      string
  ;
    
  customID :
      string
  ;
    
  errors :
      MailJetErrorResultVM[]
  ;
    
  to :
      MailJetEmailRecipientResultVM[]
  ;
    
  cc :
      MailJetEmailRecipientResultVM[]
  ;
    
  bcc :
      MailJetEmailRecipientResultVM[]
  ;

constructor() 
{
      this.status = "" ;
        this.customID = "" ;
        this.errors = [];
        this.to = [];
        this.cc = [];
        this.bcc = [];
  }
}

export

class MailJetErrorResultVM {
    
  errorIdentifier :
      string
  ;
    
  errorCode :
      string
  ;
    
  statusCode :
      string
  ;
    
  errorMessage :
      string
  ;
    
  errorRelatedTo :
      string
  ;

constructor() 
{
      this.errorIdentifier = "" ;
        this.errorCode = "" ;
        this.statusCode = "" ;
        this.errorMessage = "" ;
        this.errorRelatedTo = "" ;
  }
}

export

class MailJetEmailRecipientResultVM {
    
  email :
      string
  ;
    
  messageUUID :
      string
  ;
    
  messageID :
      string
  ;
    
  messageHref :
      string
  ;

constructor() 
{
      this.email = "" ;
        this.messageUUID = "" ;
        this.messageID = "" ;
        this.messageHref = "" ;
  }
}

export

class MailEventFilterVM {
    
  parentType :
      string[]
  ;
    
  toType :
      string[]
  ;
    
  status :
      string[]
  ;
    
  label :
      string[]
  ;

constructor() 
{
      this.parentType = [];
        this.toType = [];
        this.status = [];
        this.label = [];
  }
}

export

class MailEventVM {
    
  identifier :
      string
  ;
    
  parentObject :
      TextIdentifierType 
  ;
    
  to :
      TextIdentifierType 
  ;
    
  label :
      string
  ;
    
  variables :
      any | null
  ;
    
  templateId :
      number | null
  ;
    
  email :
      string
  ;
    
  mailJetMessageResult :
      MailJetMessageResultVM 
  ;
    
  resendMailJetMessageResults :
      ResendMailJetMessageResultVM[]
  ;

constructor() 
{
      this.identifier = "" ;
        this.parentObject = new TextIdentifierType();
        this.to = new TextIdentifierType();
        this.label = "" ;
        this.variables = null;
        this.templateId = null;
        this.email = "" ;
        this.mailJetMessageResult = new MailJetMessageResultVM();
        this.resendMailJetMessageResults = [];
  }
}

export

class ResendMailJetMessageResultVM {
    
  createdOn :
      string
  ;
    
  sentBy :
      TextIdentifierType 
  ;
    
  variables :
      any | null
  ;
    
  templateId :
      number | null
  ;
    
  email :
      string
  ;
    
  mailJetMessageResult :
      MailJetMessageResultVM 
  ;

constructor() 
{
      this.createdOn = "" ;
        this.sentBy = new TextIdentifierType();
        this.variables = null;
        this.templateId = null;
        this.email = "" ;
        this.mailJetMessageResult = new MailJetMessageResultVM();
  }
}

export

class MailjetResponseVMOfGetMessageDataVM {
    
  count :
      number | null
  ;
    
  data :
      GetMessageDataVM[]
  ;
    
  total :
      number | null
  ;

constructor() 
{
      this.count = null;
        this.data = [];
        this.total = null;
  }
}

export

class GetMessageDataVM {
    
  arrivedAt :
      string
  ;
    
  attachmentCount :
      number | null
  ;
    
  attemptCount :
      number | null
  ;
    
  contactAlt :
      string
  ;
    
  contactID :
      string
  ;
    
  delay :
      number | null
  ;
    
  destinationID :
      number | null
  ;
    
  filterTime :
      number | null
  ;
    
  id :
      string
  ;
    
  isClickTracked :
      boolean
  ;
    
  isHTMLPartIncluded :
      boolean
  ;
    
  isOpenTracked :
      boolean
  ;
    
  isTextPartIncluded :
      boolean
  ;
    
  isUnsubTracked :
      boolean
  ;
    
  messageSize :
      number | null
  ;
    
  senderID :
      string
  ;
    
  spamassassinScore :
      number | null
  ;
    
  spamassRules :
      string
  ;
    
  statePermanent :
      boolean
  ;
    
  status :
      MessageStatus | null
  ;
    
  subject :
      string
  ;
    
  uuid :
      string
  ;
    
  campaignID :
      number | null
  ;
    
  stateID :
      MessageStateID | null
  ;

constructor() 
{
      this.arrivedAt = "" ;
        this.attachmentCount = null;
        this.attemptCount = null;
        this.contactAlt = "" ;
        this.contactID = "" ;
        this.delay = null;
        this.destinationID = null;
        this.filterTime = null;
        this.id = "" ;
        this.isClickTracked = false ;
        this.isHTMLPartIncluded = false ;
        this.isOpenTracked = false ;
        this.isTextPartIncluded = false ;
        this.isUnsubTracked = false ;
        this.messageSize = null;
        this.senderID = "" ;
        this.spamassassinScore = null;
        this.spamassRules = "" ;
        this.statePermanent = false ;
        this.status = null;
        this.subject = "" ;
        this.uuid = "" ;
        this.campaignID = null;
        this.stateID = null;
  }
}

export enum MessageStatus {
    Unknown = 0,
    Queued = 1,
    Sent = 2,
    Opened = 3,
    Clicked = 4,
    Bounce = 5,
    Spam = 6,
    Unsub = 7,
    Blocked = 8,
    HardBounced = 9,
    SoftBounced = 10,
    Deferred = 11,
}

export enum MessageStateID {
    UserUnknown = 1,
    MailboxInactive = 2,
    QuotaExceeded = 3,
    InvalidDomain = 4,
    NoMailHost = 5,
    RelayAccessDenied = 6,
    SenderBlocked = 7,
    ContentBlocked = 8,
    PolicyIssue = 9,
    SystemIssue = 10,
    ProtocolIssue = 11,
    ConnectionIssue = 12,
    Greylisted = 13,
    Preblocked = 14,
    DuplicateInCampaign = 15,
    SpamPreblocked = 16,
    BadOrEmptyTemplate = 17,
    ErrorInTemplateLanguage = 18,
    Typofix = 19,
    Blacklisted = 20,
    SpamReporter = 21,
}

export

class SendMessageAgainVM {
    
  identifier :
      string
  ;
    
  templateId :
      number | null
  ;
    
  email :
      string
  ;
    
  variables :
      any | null
  ;

constructor() 
{
      this.identifier = "" ;
        this.templateId = null;
        this.email = "" ;
        this.variables = null;
  }
}

export

class Transaction extends BaseEntity {
    
  user :
      TextIdentifier 
  ;
    
  company :
      TextIdentifier 
  ;
    
  pricePaid :
      number | null
  ;
    
  product :
      TextIdentifierType 
  ;
    
  transactionId :
      string
  ;

constructor() 
{
  super();
      this.user = new TextIdentifier();
        this.company = new TextIdentifier();
        this.pricePaid = null;
        this.product = new TextIdentifierType();
        this.transactionId = "" ;
  }
}

export

class TransactionAndBoughPackageIdsBM {
    
  transactionIdentifier :
      string
  ;
    
  boughtPackageIdentifier :
      string
  ;

constructor() 
{
      this.transactionIdentifier = "" ;
        this.boughtPackageIdentifier = "" ;
  }
}

export

class AppUserTransactionCreateVM {
    
  transactionId :
      string
  ;
    
  buyablePackage :
      string
  ;

constructor() 
{
      this.transactionId = "" ;
        this.buyablePackage = "" ;
  }
}

export

class PagedResponseOfAttachmentLocalizedEntity {
    
  items :
      AttachmentLocalizedEntity[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class LocalizedValue {
    
  values :
      { [key: string]: string; }
  ;

constructor() 
{
      this.values = {};
  }
}

export

class LocalizedEntity extends LocalizedValue {
    
  key :
      string
  ;
    
  identifier :
      string
  ;

constructor() 
{
  super();
      this.key = "" ;
        this.identifier = "" ;
  }
}

export

class AttachmentLocalizedEntity extends LocalizedEntity {
    
  attachments :
      { [key: string]: AWSS3Attachment; }
  ;

constructor() 
{
  super();
      this.attachments = {};
  }
}

export

class BaseAttachment {
    
  fileIdentifier :
      string
  ;
    
  fileName :
      string
  ;
    
  mimeType :
      string
  ;
    
  lastModifiedOn :
      string
  ;
    
  subDir :
      string
  ;

constructor() 
{
      this.fileIdentifier = "" ;
        this.fileName = "" ;
        this.mimeType = "" ;
        this.lastModifiedOn = "" ;
        this.subDir = "" ;
  }
}

export

class AWSS3Attachment extends BaseAttachment {
    
  region :
      string
  ;
    
  bucket :
      string
  ;

constructor() 
{
  super();
      this.region = "" ;
        this.bucket = "" ;
  }
}

export

class KeyValuePairOfStringAndString {
    
  key :
      string
  ;
    
  value :
      string
  ;

constructor() 
{
      this.key = "" ;
        this.value = "" ;
  }
}

export

class PagedResponseOfLocalizedEntity {
    
  items :
      LocalizedEntity[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class PagedResponseOfOverrideAttachmentLocalizedEntity {
    
  items :
      OverrideAttachmentLocalizedEntity[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class OverrideLocalizedEntity extends BaseEntity {
    
  company :
      TextIdentifier 
  ;
    
  key :
      string
  ;
    
  overrideReference :
      TextIdentifier 
  ;
    
  values :
      { [key: string]: string; }
  ;

constructor() 
{
  super();
      this.company = new TextIdentifier();
        this.key = "" ;
        this.overrideReference = new TextIdentifier();
        this.values = {};
  }
}

export

class OverrideAttachmentLocalizedEntity extends OverrideLocalizedEntity {
    
  attachments :
      { [key: string]: AWSS3Attachment; }
  ;

constructor() 
{
  super();
      this.attachments = {};
  }
}

export

class PagedResponseOfOverrideLocalizedEntity {
    
  items :
      OverrideLocalizedEntity[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class CreateOverrideLocalizedEntityVM {
    
  companyIdentifier :
      string
  ;
    
  values :
      { [key: string]: string; }
  ;
    
  dictionaryReference :
      string
  ;

constructor() 
{
      this.companyIdentifier = "" ;
        this.values = {};
        this.dictionaryReference = "" ;
  }
}

export

class EditOverrideLocalizedEntityVM {
    
  identifier :
      string
  ;
    
  values :
      { [key: string]: string; }
  ;

constructor() 
{
      this.identifier = "" ;
        this.values = {};
  }
}

export

class CreateBookingVM {
    
  appUserIdentifier :
      string
  ;
    
  consulenteUserIdentifier :
      string
  ;
    
  isForFamigliare :
      boolean
  ;
    
  additionalData :
      { [key: string]: string[]; }
  ;
    
  categoryIdentifier :
      string
  ;
    
  companyIdentifier :
      string
  ;
    
  period :
      DatePeriod 
  ;
    
  boughtPackageIdentifier :
      string
  ;

constructor() 
{
      this.appUserIdentifier = "" ;
        this.consulenteUserIdentifier = "" ;
        this.isForFamigliare = false ;
        this.additionalData = {};
        this.categoryIdentifier = "" ;
        this.companyIdentifier = "" ;
        this.period = new DatePeriod();
        this.boughtPackageIdentifier = "" ;
  }
}

export

class PagedResponseOfBookingAdminListVM {
    
  items :
      BookingAdminListVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class BookingListVM {
    
  identifier :
      string
  ;
    
  createdOn :
      string
  ;
    
  period :
      CustomDatePeriod 
  ;
    
  cancelledOn :
      string
  ;
    
  cancelledBy :
      TextIdentifier 
  ;
    
  category :
      TextIdentifier 
  ;
    
  appUser :
      TextIdentifier 
  ;
    
  appUserCompleteName :
      string
  ;
    
  company :
      TextIdentifier 
  ;
    
  isFree :
      boolean
  ;
    
  isForFamigliare :
      boolean
  ;
    
  isFirstFreeBooking :
      boolean
  ;
    
  linkIncontro :
      string
  ;
    
  boughtPackageUsed :
      TextIdentifier 
  ;
    
  additionalData :
      { [key: string]: string[]; }
  ;

constructor() 
{
      this.identifier = "" ;
        this.createdOn = "" ;
        this.period = new CustomDatePeriod();
        this.cancelledOn = "" ;
        this.cancelledBy = new TextIdentifier();
        this.category = new TextIdentifier();
        this.appUser = new TextIdentifier();
        this.appUserCompleteName = "" ;
        this.company = new TextIdentifier();
        this.isFree = false ;
        this.isForFamigliare = false ;
        this.isFirstFreeBooking = false ;
        this.linkIncontro = "" ;
        this.boughtPackageUsed = new TextIdentifier();
        this.additionalData = {};
  }
}

export

class BookingAdminListVM extends BookingListVM {
    
  createdBy :
      TextIdentifierType 
  ;
    
  consulenteUser :
      TextIdentifier 
  ;
    
  consulenteUserCompleteName :
      string
  ;
    
  overrideCategoryCountedAsReservation :
      OverrideCategoryCountedAsReservation 
  ;
    
  isAppUserFamilyUser :
      boolean
  ;

constructor() 
{
  super();
      this.createdBy = new TextIdentifierType();
        this.consulenteUser = new TextIdentifier();
        this.consulenteUserCompleteName = "" ;
        this.overrideCategoryCountedAsReservation = new OverrideCategoryCountedAsReservation();
        this.isAppUserFamilyUser = false ;
  }
}

export

class OverrideCategoryCountedAsReservation {
    
  createdOn :
      string
  ;
    
  categoryCountedAsReservation :
      boolean
  ;
    
  createdBy :
      TextIdentifierType 
  ;
    
  note :
      string
  ;

constructor() 
{
      this.createdOn = "" ;
        this.categoryCountedAsReservation = false ;
        this.createdBy = new TextIdentifierType();
        this.note = "" ;
  }
}

export

class UpdateLinkIncontroVM2 {
    
  bookingIdentifier :
      string
  ;
    
  meetingLink :
      string
  ;

constructor() 
{
      this.bookingIdentifier = "" ;
        this.meetingLink = "" ;
  }
}

export

class BookingUserAdditionalDataVM {
    
  lastUserReservation :
      { [key: string]: string[]; }
  ;
    
  lastFamilyReservation :
      { [key: string]: string[]; }
  ;
    
  lastCategoryUserReservation :
      { [key: string]: string[]; }
  ;
    
  lastCategoryFamilyReservation :
      { [key: string]: string[]; }
  ;

constructor() 
{
      this.lastUserReservation = {};
        this.lastFamilyReservation = {};
        this.lastCategoryUserReservation = {};
        this.lastCategoryFamilyReservation = {};
  }
}

export

class AppUserBookingListVM {
    
  identifier :
      string
  ;
    
  category :
      TextIdentifier 
  ;
    
  consulenteUser :
      TextIdentifier 
  ;
    
  period :
      DatePeriod 
  ;
    
  consulenteImage :
      string
  ;
    
  titoloProfessionale :
      string
  ;
    
  cancelledOn :
      string
  ;
    
  unreadCount :
      number | null
  ;
    
  chatRoomId :
      string
  ;
    
  overrideCategoryCountedAsReservation :
      OverrideCategoryCountedAsReservation 
  ;

constructor() 
{
      this.identifier = "" ;
        this.category = new TextIdentifier();
        this.consulenteUser = new TextIdentifier();
        this.period = new DatePeriod();
        this.consulenteImage = "" ;
        this.titoloProfessionale = "" ;
        this.cancelledOn = "" ;
        this.unreadCount = null;
        this.chatRoomId = "" ;
        this.overrideCategoryCountedAsReservation = new OverrideCategoryCountedAsReservation();
  }
}

export

class AppUserBookingDetailVM {
    
  identifier :
      string
  ;
    
  categorySettings :
      CategorySettings 
  ;
    
  consulenteUser :
      TextIdentifier 
  ;
    
  category :
      TextIdentifier 
  ;
    
  period :
      DatePeriod 
  ;
    
  boughtPackageUsed :
      TextIdentifier 
  ;
    
  isForFamigliare :
      boolean
  ;
    
  linkIncontro :
      string
  ;
    
  additionalData :
      { [key: string]: string[]; }
  ;
    
  cancelledOn :
      string
  ;
    
  titoloProfessionale :
      string
  ;
    
  consulenteImage :
      string
  ;
    
  overrideCategoryCountedAsReservation :
      OverrideCategoryCountedAsReservation 
  ;

constructor() 
{
      this.identifier = "" ;
        this.categorySettings = new CategorySettings();
        this.consulenteUser = new TextIdentifier();
        this.category = new TextIdentifier();
        this.period = new DatePeriod();
        this.boughtPackageUsed = new TextIdentifier();
        this.isForFamigliare = false ;
        this.linkIncontro = "" ;
        this.additionalData = {};
        this.cancelledOn = "" ;
        this.titoloProfessionale = "" ;
        this.consulenteImage = "" ;
        this.overrideCategoryCountedAsReservation = new OverrideCategoryCountedAsReservation();
  }
}

export

class UpdateOverrideCategoryCountedAsReservationVM {
    
  identifier :
      string
  ;
    
  note :
      string
  ;

constructor() 
{
      this.identifier = "" ;
        this.note = "" ;
  }
}

export

class AppUserCreateBookingVM {
    
  consulenteUserIdentifier :
      string
  ;
    
  isForFamigliare :
      boolean
  ;
    
  additionalData :
      { [key: string]: string[]; }
  ;
    
  categoryIdentifier :
      string
  ;
    
  period :
      DatePeriod 
  ;
    
  boughtPackageIdentifier :
      string
  ;

constructor() 
{
      this.consulenteUserIdentifier = "" ;
        this.isForFamigliare = false ;
        this.additionalData = {};
        this.categoryIdentifier = "" ;
        this.period = new DatePeriod();
        this.boughtPackageIdentifier = "" ;
  }
}

export

class AppUserCreateBookingFirstConsulentAvailableVM {
    
  isForFamigliare :
      boolean
  ;
    
  additionalData :
      { [key: string]: string[]; }
  ;
    
  categoryIdentifier :
      string
  ;
    
  period :
      DatePeriod 
  ;
    
  boughtPackageIdentifier :
      string
  ;

constructor() 
{
      this.isForFamigliare = false ;
        this.additionalData = {};
        this.categoryIdentifier = "" ;
        this.period = new DatePeriod();
        this.boughtPackageIdentifier = "" ;
  }
}

export

class AppUserChangeBookingDateVM {
    
  bookingIdentifier :
      string
  ;
    
  period :
      DatePeriod 
  ;

constructor() 
{
      this.bookingIdentifier = "" ;
        this.period = new DatePeriod();
  }
}

export

class CategoryBookingCountVM {
    
  categoryName :
      string
  ;
    
  count :
      number | null
  ;

constructor() 
{
      this.categoryName = "" ;
        this.count = null;
  }
}

export

class PagedResponseOfBookingRequest {
    
  items :
      BookingRequest[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class BookingRequest extends BaseEntity {
    
  bookingIdentifier :
      string
  ;
    
  appUser :
      TextIdentifier 
  ;
    
  category :
      TextIdentifier 
  ;
    
  company :
      TextIdentifier 
  ;
    
  boughtPackageUsed :
      TextIdentifier 
  ;
    
  isForFamigliare :
      boolean
  ;
    
  isAppUserFamilyUser :
      boolean
  ;
    
  additionalData :
      { [key: string]: string[]; }
  ;
    
  lastStatus :
      BookingRequestStatusDetail 
  ;
    
  statusHistory :
      BookingRequestStatusDetail[]
  ;

constructor() 
{
  super();
      this.bookingIdentifier = "" ;
        this.appUser = new TextIdentifier();
        this.category = new TextIdentifier();
        this.company = new TextIdentifier();
        this.boughtPackageUsed = new TextIdentifier();
        this.isForFamigliare = false ;
        this.isAppUserFamilyUser = false ;
        this.additionalData = {};
        this.lastStatus = new BookingRequestStatusDetail();
        this.statusHistory = [];
  }
}

export

class BookingRequestStatusDetail {
    
  createdOn :
      string
  ;
    
  changedBy :
      TextIdentifier 
  ;
    
  status :
      BookingRequestStatus | null
  ;
    
  description :
      string
  ;

constructor() 
{
      this.createdOn = "" ;
        this.changedBy = new TextIdentifier();
        this.status = null;
        this.description = "" ;
  }
}

export enum BookingRequestStatus {
    Created = 1,
    Accepted = 2,
    Rejected = 3,
    Voided = 4,
}

export

class RejectRequestVM {
    
  requestIdentifier :
      string
  ;
    
  description :
      string
  ;

constructor() 
{
      this.requestIdentifier = "" ;
        this.description = "" ;
  }
}

export

class AcceptRequestVM {
    
  requestIdentifier :
      string
  ;
    
  consulenteIdentifier :
      string
  ;
    
  period :
      DatePeriod 
  ;

constructor() 
{
      this.requestIdentifier = "" ;
        this.consulenteIdentifier = "" ;
        this.period = new DatePeriod();
  }
}

export

class AppUserBookingRequestVM {
    
  identifier :
      string
  ;
    
  isForFamigliare :
      boolean
  ;
    
  boughtPackageUsed :
      TextIdentifier 
  ;
    
  additionalData :
      { [key: string]: string[]; }
  ;

constructor() 
{
      this.identifier = "" ;
        this.isForFamigliare = false ;
        this.boughtPackageUsed = new TextIdentifier();
        this.additionalData = {};
  }
}

export

class AppUserCreateRequestVM {
    
  categoryIdentifier :
      string
  ;
    
  boughtPackageIdentifier :
      string
  ;
    
  isForFamigliare :
      boolean
  ;
    
  additionalData :
      { [key: string]: string[]; }
  ;

constructor() 
{
      this.categoryIdentifier = "" ;
        this.boughtPackageIdentifier = "" ;
        this.isForFamigliare = false ;
        this.additionalData = {};
  }
}

export

class PagedResponseOfHolidayBooking {
    
  items :
      HolidayBooking[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class BaseBooking extends BaseEntity {
    
  createdBy :
      TextIdentifierType 
  ;
    
  consulenteUser :
      TextIdentifier 
  ;
    
  period :
      CustomDatePeriod 
  ;
    
  disabledData :
      DisabledData 
  ;

constructor() 
{
  super();
      this.createdBy = new TextIdentifierType();
        this.consulenteUser = new TextIdentifier();
        this.period = new CustomDatePeriod();
        this.disabledData = new DisabledData();
  }
}

export

class HolidayBooking extends BaseBooking {
    
  description :
      string
  ;
    
  allDay :
      boolean
  ;

constructor() 
{
  super();
      this.description = "" ;
        this.allDay = false ;
  }
}

export

class PagedResponseOfHolidayBookingConsulenteListVM {
    
  items :
      HolidayBookingConsulenteListVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class HolidayBookingConsulenteListVM {
    
  identifier :
      string
  ;
    
  description :
      string
  ;
    
  consulenteUser :
      TextIdentifier 
  ;
    
  period :
      CustomDatePeriod 
  ;
    
  allDay :
      boolean
  ;

constructor() 
{
      this.identifier = "" ;
        this.description = "" ;
        this.consulenteUser = new TextIdentifier();
        this.period = new CustomDatePeriod();
        this.allDay = false ;
  }
}

export

class CreateHolidayBookingVM {
    
  consulenteIdentifier :
      string
  ;
    
  period :
      DatePeriod 
  ;
    
  allDay :
      boolean
  ;
    
  description :
      string
  ;

constructor() 
{
      this.consulenteIdentifier = "" ;
        this.period = new DatePeriod();
        this.allDay = false ;
        this.description = "" ;
  }
}

export

class CreateMyHolidayBookingVM {
    
  period :
      DatePeriod 
  ;
    
  description :
      string
  ;
    
  allDay :
      boolean
  ;

constructor() 
{
      this.period = new DatePeriod();
        this.description = "" ;
        this.allDay = false ;
  }
}

export

class UpdateHolidayBookingVM {
    
  identifier :
      string
  ;
    
  period :
      DatePeriod 
  ;
    
  description :
      string
  ;
    
  allDay :
      boolean
  ;

constructor() 
{
      this.identifier = "" ;
        this.period = new DatePeriod();
        this.description = "" ;
        this.allDay = false ;
  }
}

export

class PagedResponseOfBookingConfiguration {
    
  items :
      BookingConfiguration[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class BaseFieldConfiguration extends BaseEntity {
    
  company :
      TextIdentifier 
  ;
    
  additionalField :
      TextIdentifierType 
  ;

constructor() 
{
  super();
      this.company = new TextIdentifier();
        this.additionalField = new TextIdentifierType();
  }
}

export

class BookingConfiguration extends BaseFieldConfiguration {
    
  bookingConfigurationType :
      BookingConfigurationType | null
  ;

constructor() 
{
  super();
      this.bookingConfigurationType = null;
  }
}

export

class PagedResponseOfBookingConfigurationVM {
    
  items :
      BookingConfigurationVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class BookingConfigurationVM {
    
  identifier :
      string
  ;
    
  company :
      TextIdentifier 
  ;
    
  additionalField :
      AdditionalFieldVM 
  ;
    
  bookingConfigurationType :
      BookingConfigurationType | null
  ;

constructor() 
{
      this.identifier = "" ;
        this.company = new TextIdentifier();
        this.additionalField = new AdditionalFieldVM();
        this.bookingConfigurationType = null;
  }
}

export

class AdditionalFieldVM extends TextIdentifierType {
    
  isRequired :
      boolean
  ;
    
  primaryKey :
      boolean
  ;
    
  primaryKeyForeachCompany :
      boolean
  ;
    
  options :
      FieldOption[]
  ;

constructor() 
{
  super();
      this.isRequired = false ;
        this.primaryKey = false ;
        this.primaryKeyForeachCompany = false ;
        this.options = [];
  }
}

export

class TextIdentifierWithBookingConfigurationTypeVM extends TextIdentifier {
    
  bookingConfigurationType :
      BookingConfigurationType | null
  ;

constructor() 
{
  super();
      this.bookingConfigurationType = null;
  }
}

export

class AddDefaultBaseFieldVM {
    
  baseFieldIdentifier :
      string
  ;

constructor() 
{
      this.baseFieldIdentifier = "" ;
  }
}

export

class AddDefaultBookingBaseFieldVM extends AddDefaultBaseFieldVM {
    
  bookingConfigurationType :
      BookingConfigurationType | null
  ;

constructor() 
{
  super();
      this.bookingConfigurationType = null;
  }
}

export

class AddBaseFieldVM extends AddDefaultBaseFieldVM {
    
  companyIdentifier :
      string
  ;

constructor() 
{
  super();
      this.companyIdentifier = "" ;
  }
}

export

class AddBookingBaseFieldVM extends AddBaseFieldVM {
    
  bookingConfigurationType :
      BookingConfigurationType | null
  ;

constructor() 
{
  super();
      this.bookingConfigurationType = null;
  }
}

export

class AddDefaultCombinationFieldVM {
    
  combinationIdentifier :
      string
  ;

constructor() 
{
      this.combinationIdentifier = "" ;
  }
}

export

class AddDefaultBookingCombinationFieldVM extends AddDefaultCombinationFieldVM {
    
  bookingConfigurationType :
      BookingConfigurationType | null
  ;

constructor() 
{
  super();
      this.bookingConfigurationType = null;
  }
}

export

class AddCombinationFieldVM extends AddDefaultCombinationFieldVM {
    
  companyIdentifier :
      string
  ;

constructor() 
{
  super();
      this.companyIdentifier = "" ;
  }
}

export

class AddBookingCombinationFieldVM extends AddCombinationFieldVM {
    
  bookingConfigurationType :
      BookingConfigurationType | null
  ;

constructor() 
{
  super();
      this.bookingConfigurationType = null;
  }
}

export

class PagedResponseOfRegistrationConfiguration {
    
  items :
      RegistrationConfiguration[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class RegistrationConfiguration extends BaseFieldConfiguration {

constructor() 
{
  super();
}
}

export

class PagedResponseOfRegistrationConfigurationVM {
    
  items :
      RegistrationConfigurationVM[]
  ;
    
  totalItemsCount :
      number | null
  ;

constructor() 
{
      this.items = [];
        this.totalItemsCount = null;
  }
}

export

class RegistrationConfigurationVM {
    
  identifier :
      string
  ;
    
  company :
      TextIdentifier 
  ;
    
  additionalField :
      AdditionalFieldVM 
  ;

constructor() 
{
      this.identifier = "" ;
        this.company = new TextIdentifier();
        this.additionalField = new AdditionalFieldVM();
  }
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class PagedRequestVM {
    paging: PagingFilter;
    sortBy: SortByParameter | null;
    filter: { [key: string]: string[] };

    constructor() {
        this.paging =  {
            currentPage : 1,
            itemsPerPage : 15,
            skip : 0,
            take : 15,
        };
        this.sortBy = null;
        this.filter = {};
    }
}

export class PagedRequestWithIdentifierVM extends PagedRequestVM {
    identifier : string;

    constructor() 
    {
        super();
        this.identifier = "" ;
    }
}

export class PagingFilter {
    currentPage: number | null;
    itemsPerPage: number | null;
    skip: number | null;
    take: number | null;

    constructor() {
        this.currentPage = null;
        this.itemsPerPage = null;
        this.skip = null;
        this.take = null;
    }
}

export class SortByParameter {
    propertyName: string;
    ascending: boolean;

    constructor() {
        this.propertyName = "";
        this.ascending = false;
    }
}